import React, {Component} from "react";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import { Calendar } from 'primereact/calendar';
import {Dropdown} from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Chart } from 'primereact/chart';
import { Card } from 'primereact/card';
import axios from '../../axios-url';
import { ResponsiveNetwork } from '@nivo/network';
import { ResponsiveAreaBump } from '@nivo/bump';
import { ResponsiveBump } from '@nivo/bump';
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveChord } from '@nivo/chord';
//import { countries } from './index.ts';
import { ResponsiveChoropleth } from '@nivo/geo';

import { ResponsiveFunnel } from '@nivo/funnel'
// import { ResponsiveHeatMap } from '@nivo/heatmap'
//import { ResponsiveLine } from '@nivo/line';
import { ResponsiveMarimekko } from '@nivo/marimekko'
import { ResponsiveRadar } from '@nivo/radar'
import { ResponsiveSwarmPlot } from '@nivo/swarmplot'
import { ResponsiveScatterPlot } from '@nivo/scatterplot'
import { ResponsiveCirclePacking } from '@nivo/circle-packing'
import { DROPDOWN_CONFIG,USER_SUBMENU_ID} from '../../shared/Config';
import { REDIRECT_TO_URL, HASACCESS } from '../../shared/utility';
import { Toast } from 'primereact/toast';
import Messages from '../../shared/UI/Messages/Messages';



class OrgStruct extends Component {
     constructor(props){
         super(props);
        this.state = {
          organizationData: [],
          Fromdate: null,
          ToDate: null,
          SelectedOrg:null,
          GetOrgUnit: [],
          GraphDate:[],
          touch:false,
          loading: false,
          Department: [
            {label: 'Purchase Dep', value: '99BDDDB4-77EB-479A-9673-0A865F23CCC9'},
            {label: 'Finance', value: '8EF08393-9DB8-4654-83EC-134C6015A074'},
            {label : 'IT Dept',value : 'EB9323B6-AB93-4453-914C-26286F824C00'},
            {label : 'HSE',value : 'D55895CA-D7FC-4E5F-BBB7-30D195D475F1'},
            {label: 'Apprentice', value: '7EADDA05-B367-448F-8A33-654FC83EB07D'},
            {label: 'Chemist Depa', value: 'B63D1B09-67B3-40BA-8808-675DA62A82BE'},
            {label: 'Accountant', value: '1C51468A-BE18-42BE-832E-6C79A3A5A10F'},
            {label: 'Ware House', value: 'D5EBDE56-1670-4BA5-96A9-77C523DF9C3C'},
            {label: 'Engineering', value: '3A055B98-C7CE-4498-90C8-795B6C722590'},
            {label: 'Maintenance', value: '5708A1DF-01BE-48B5-881E-79B2D2AA30F7'},
            {label: 'Training Dep', value: 'B98A1E76-A9B7-446D-8EC1-8BBCA8090669'},
            {label: 'HR & Admin', value: '76B77363-3BAB-4780-BB29-9BAB5B7949C2'},
            {label: 'HR departmen', value: 'B423B9DA-737A-4BC0-9195-B93E4F16FCE3'},
            {label: 'Lead Mech En', value: '7F2C8AB4-57D9-4770-9B29-BD200F3AF45E'},
            {label: 'Lead C&I Eng', value: 'C26E20D6-F5FE-4E48-8F9B-BF6A260B7A67'},
            {label: 'Deputy Opera', value: '43698F7A-B3FA-488C-982B-CEE4C7305E9E'},
            {label: 'Performance', value: '76F0B9B0-7580-43E3-8330-D364D11C626D'},
            {label: 'Lead El Eng', value: '831C833E-355E-4F34-B23F-D6C3FC2E1389'},
            {label: 'Planning Eng', value: '4FA056A1-7834-4F38-87A8-D78AE5AD58BE'},
            {label: 'Operations', value: '0879E6FD-30AE-4BFB-9987-DE5DDADD8D13'},
            {label: 'Conditioning', value: 'C39CD747-C43C-4CA8-9910-ED44DC6D1B79'},
            {label: 'Security Dep', value: '80354382-9FF6-4D29-8BC7-EF901C4356DD'},
            
        ],

        }
        //this.change = this.change.bind(this);
    }



    // make sure parent container have a defined height when using
    // responsive component, otherwise height will be 0 and
    // no chart will be rendered.
    // website examples showcase many properties,
    // you'll often use just a few of them.





    componentDidMount(){

     console.log({props:this.props})
      this.props.getRequest()
      this.props.getMasterKeywordList('OrgUnit');
      this.props.GetPositionHierachyGraph();
      this.getAccess = HASACCESS(USER_SUBMENU_ID);
      let id = this.props.match.params.id;
      // let id = '62867995-df10-4eed-ad62-33f2e468b905';
      this.props.getMasterTableList('GeUsers?id=' + id);   
      
    //   axios.get('/master/api/GetHRAnalytics?EMPLOYEEID="b2019f12-59bd-4ba2-916b-92e3d4f6bd65"&YEAR="2021"&MONTH="01"&DEPARTMENTNO="10000005"').then((response) => {
    //     if (response.status === 200) {

    //         if (response.data && response.data.length > 0) {
    //             let GraphDate = response.data;
    //             this.setState({GraphDate: GraphDate})
    //         }

    //     }
    // })
 
    axios.get('/master/api/Request/GetGraphData').then((response) => {
      if (response.status === 200) {

          if (response.data && response.data.length > 0) {
              let GraphDate = response.data;
              this.setState({GraphDate: GraphDate})
          }

      }
  })      
      
     //   axios.get('/master/api/GetHRAnalytics?EMPLOYEEID="b2019f12-59bd-4ba2-916b-92e3d4f6bd65"&YEAR="2021"&MONTH="01"&DEPARTMENTNO="10000005"').then((response) => {
            // console.log({response})
     //   })
     this.setState({ loading: true });
     setTimeout(() =>{
      // if(this.props.requestListData[4] !== undefined){
      //     if(this.props.requestListData[4].length > 0){
      //         this.setState({showteamMembers: true})
      //     }
      // }
      // if (this.state.viewCalendarFor== undefined){
      // this.setState({viewCalendarFor:this.props.loggedUserDetail.empID});
      // }
     
  },10000)
  this.setState({ loading: false });
        // axios.get('/master/api/Employee/GetPositionHierachyGraph').then((response) => {
        //     if (response.status === 200) {

        //         if (response.data && response.data.length > 0) {
        //             let organizationData = response.data;
        //             //organizationData = [...new Set(organizationData.map(({ name,color,loc,children }) => ({name,color,loc,children})))];
        //             organizationData = [...new Set(organizationData.map(({ name, color, loc, children }) => ({name,color,loc,
        //               children: children.map(({ name,color,loc,children }) => ({name,color,loc,children: children.map(({ name,color,loc,children }) => ({name,color,loc,children:children.map(({ name,color,loc }) => ({name,color,loc })) })) })),
        //             })))];
        //              //console.log({organizationData})
        //              this.setState({ organizationData});
        //              this.setState({ loading: false });
        //         }
        //     }
        //     else {
        //         this.setState({ loading: false });
        //         this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
        //     }
        // })
        //this.timer();
        
    }
    // timer = () =>{
    //   this.intervalID = setInterval(()=> {
    //       this.fetchSingleProcess();
    //   },2000)
 // }  
//   fetchSingleProcess = () =>{

//     let storageItems = [];
//     if(this.props.OrgUnit!==undefined) {
//         storageItems = this.props.OrgUnit;
//         clearInterval(this.intervalID);
//     }
//     if(storageItems){
//         let filterData = storageItems;
//         if(filterData){
//             let org ='';
//             if(filterData!=null){
//                 org = filterData.split(",") 
//             }

//             var data = {
           
//                 orgid: org,
//             }
//             this.setState(data);
            
//         }
//     }

// }


    shouldComponentUpdate(prevProps, prevState){
      if (prevProps.positionhierarchyData !== this.props.positionhierarchyData) {
        return true;
    } else {
        return false;
    }
    }


    updateDetail = (e) => {
      const { name, value} = e.target;
      this.setState({[name]:value});
  }
  change = (e) => {
    let {name, value} = e.target;
    this.setState({[name]:value})
}

    render(){
      // let depOptions = [];
      const { positionhierarchyData } = this.props;
      const { GraphData } = this.state;
      //  if(positionhierarchyData && positionhierarchyData.length > 0 ){
      //   let organizationData = this.props.positionhierarchyData
      //  // let organizationData = [...new Set(positionhierarchyData.map(({ name,color,loc,children }) => ({name,color,loc,children})))];
      //   organizationData = {...organizationData.map(({ name, color, children }) => ({name,color,
      //     children: children.map(({ name,color,children }) => ({name,color,children: children.map(({ name,color,children }) => ({name,color,children:children.map(({ name,color,loc }) => ({name,color,loc })) })) })),
      //   }))};
      //   this.setState({ organizationData});
      //  }
      
      // if(this.props.emp && this.props.emp.length > 0 ){
      //   depOptions = this.props.emp;
      // }
       // const { requestListData} = this.props;

        
        let isEnabled = (this.state.touch === true);

        const bumpd=  

[
  {
    "id": "JavaScript",
    "data": [
      {
        "x": 2000,
        "y": 12
      },
      {
        "x": 2001,
        "y": 22
      },
      {
        "x": 2002,
        "y": 11
      },
      {
        "x": 2003,
        "y": 16
      },
      {
        "x": 2004,
        "y": 23
      },
      {
        "x": 2005,
        "y": 17
      }
    ]
  },
  {
    "id": "ReasonML",
    "data": [
      {
        "x": 2000,
        "y": 25
      },
      {
        "x": 2001,
        "y": 14
      },
      {
        "x": 2002,
        "y": 18
      },
      {
        "x": 2003,
        "y": 20
      },
      {
        "x": 2004,
        "y": 27
      },
      {
        "x": 2005,
        "y": 16
      }
    ]
  },
  {
    "id": "TypeScript",
    "data": [
      {
        "x": 2000,
        "y": 20
      },
      {
        "x": 2001,
        "y": 11
      },
      {
        "x": 2002,
        "y": 25
      },
      {
        "x": 2003,
        "y": 14
      },
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 25
      }
    ]
  },
  {
    "id": "Elm",
    "data": [
      {
        "x": 2000,
        "y": 17
      },
      {
        "x": 2001,
        "y": 30
      },
      {
        "x": 2002,
        "y": 25
      },
      {
        "x": 2003,
        "y": 22
      },
      {
        "x": 2004,
        "y": 26
      },
      {
        "x": 2005,
        "y": 29
      }
    ]
  },
  {
    "id": "CoffeeScript",
    "data": [
      {
        "x": 2000,
        "y": 13
      },
      {
        "x": 2001,
        "y": 20
      },
      {
        "x": 2002,
        "y": 19
      },
      {
        "x": 2003,
        "y": 24
      },
      {
        "x": 2004,
        "y": 17
      },
      {
        "x": 2005,
        "y": 13
      }
    ]
  }
]
            
const bard = [
    {
      "country": "AD",
      "hot dog": 182,
      "hot dogColor": "hsl(70, 70%, 50%)",
      "burger": 170,
      "burgerColor": "hsl(146, 70%, 50%)",
      "sandwich": 183,
      "sandwichColor": "hsl(106, 70%, 50%)",
      "kebab": 69,
      "kebabColor": "hsl(303, 70%, 50%)",
      "fries": 33,
      "friesColor": "hsl(303, 70%, 50%)",
      "donut": 90,
      "donutColor": "hsl(341, 70%, 50%)"
    },
    {
      "country": "AE",
      "hot dog": 99,
      "hot dogColor": "hsl(74, 70%, 50%)",
      "burger": 99,
      "burgerColor": "hsl(283, 70%, 50%)",
      "sandwich": 129,
      "sandwichColor": "hsl(102, 70%, 50%)",
      "kebab": 0,
      "kebabColor": "hsl(170, 70%, 50%)",
      "fries": 155,
      "friesColor": "hsl(249, 70%, 50%)",
      "donut": 48,
      "donutColor": "hsl(23, 70%, 50%)"
    },
    {
      "country": "AF",
      "hot dog": 128,
      "hot dogColor": "hsl(70, 70%, 50%)",
      "burger": 107,
      "burgerColor": "hsl(104, 70%, 50%)",
      "sandwich": 71,
      "sandwichColor": "hsl(144, 70%, 50%)",
      "kebab": 15,
      "kebabColor": "hsl(315, 70%, 50%)",
      "fries": 76,
      "friesColor": "hsl(61, 70%, 50%)",
      "donut": 34,
      "donutColor": "hsl(36, 70%, 50%)"
    },
    {
      "country": "AG",
      "hot dog": 89,
      "hot dogColor": "hsl(318, 70%, 50%)",
      "burger": 154,
      "burgerColor": "hsl(240, 70%, 50%)",
      "sandwich": 102,
      "sandwichColor": "hsl(46, 70%, 50%)",
      "kebab": 153,
      "kebabColor": "hsl(226, 70%, 50%)",
      "fries": 193,
      "friesColor": "hsl(350, 70%, 50%)",
      "donut": 33,
      "donutColor": "hsl(247, 70%, 50%)"
    },
    {
      "country": "AI",
      "hot dog": 51,
      "hot dogColor": "hsl(3, 70%, 50%)",
      "burger": 157,
      "burgerColor": "hsl(70, 70%, 50%)",
      "sandwich": 174,
      "sandwichColor": "hsl(126, 70%, 50%)",
      "kebab": 21,
      "kebabColor": "hsl(186, 70%, 50%)",
      "fries": 12,
      "friesColor": "hsl(205, 70%, 50%)",
      "donut": 36,
      "donutColor": "hsl(163, 70%, 50%)"
    },
    {
      "country": "AL",
      "hot dog": 126,
      "hot dogColor": "hsl(71, 70%, 50%)",
      "burger": 140,
      "burgerColor": "hsl(17, 70%, 50%)",
      "sandwich": 174,
      "sandwichColor": "hsl(242, 70%, 50%)",
      "kebab": 131,
      "kebabColor": "hsl(261, 70%, 50%)",
      "fries": 52,
      "friesColor": "hsl(247, 70%, 50%)",
      "donut": 134,
      "donutColor": "hsl(128, 70%, 50%)"
    },
    {
      "country": "AM",
      "hot dog": 186,
      "hot dogColor": "hsl(339, 70%, 50%)",
      "burger": 28,
      "burgerColor": "hsl(342, 70%, 50%)",
      "sandwich": 117,
      "sandwichColor": "hsl(130, 70%, 50%)",
      "kebab": 136,
      "kebabColor": "hsl(234, 70%, 50%)",
      "fries": 27,
      "friesColor": "hsl(28, 70%, 50%)",
      "donut": 197,
      "donutColor": "hsl(59, 70%, 50%)"
    }
  ]
  const piedOTpercentage = [
    {
      "id": "Int. Business Travel",
      "label": "Int. Business Travel",
      "value": 506,
      "color": "hsl(302, 70%, 50%)"
    },
    {
      "id": "Children Education",
      "label": "Children Education",
      "value": 55,
      "color": "hsl(11, 70%, 50%)"
    },
    {
      "id": "House Rent Reimb",
      "label": "House Rent Reimb",
      "value": 538,
      "color": "hsl(238, 70%, 50%)"
    },
    {
      "id": "Insurance",
      "label": " Insurance",
      "value": 100,
      "color": "hsl(253, 70%, 50%)"
    },
    {
      "id": "Local Travel",
      "label": "Local Travel",
      "value": 60,
      "color": "hsl(84, 70%, 50%)"
    }
      ]
      
      const pieexpensebyhighlow = [
        {
          "id": "Int. Business Travel",
          "label": "Int. Business Travel",
          "value": 506,
          "color": "hsl(302, 70%, 50%)"
        },
        {
          "id": "Children Education",
          "label": "Children Education",
          "value": 55,
          "color": "hsl(11, 70%, 50%)"
        },
          ]
          

      const piedExpenseDepartment = [
        {
          "id": "Finance",
          "label": "International Business Travel",
          "value": 506,
          "color": "hsl(302, 70%, 50%)"
        },
        {
          "id": "HR & Admin",
          "label": "Children Education Expense",
          "value": 55,
          "color": "hsl(11, 70%, 50%)"
        },
        {
          "id": "Operation",
          "label": "House Rent Reimbursement",
          "value": 538,
          "color": "hsl(238, 70%, 50%)"
        },
        {
          "id": "Maintenance",
          "label": "Family Medical Insurance",
          "value": 100,
          "color": "hsl(253, 70%, 50%)"
        },
        {
          "id": "Procurement",
          "label": "Local Travel",
          "value": 60,
          "color": "hsl(84, 70%, 50%)"
        }
      ]    
      const piedcheckintime = piedOTpercentage;
      const piedbestemployeeofmonth = piedOTpercentage;

// const piedOTpercentage = GraphData[10];
// const piedcheckintime = GraphData[11];
// const piedbestemployeeofmonth = GraphData[12];
        const data1 = {
            "nodes": [
              {
                "id": "Node 1",
                "height": 1,
                "size": 24,
                "color": "rgb(97, 205, 187)",
                "label": '12345678'
              },
              {
                "id": "Node 2",
                "height": 1,
                "size": 24,
                "color": "rgb(97, 205, 187)",
                "label": "12345678"
              },
              {
                "id": "Node 0",
                "height": 2,
                "size": 32,
                "color": "rgb(244, 117, 96)",
                "label": "12345678"
              },
              {
                "id": "Node 1.0",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 1.1",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 1.2",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 2.0",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 2.1",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label":  "12345678"
              },
              {
                "id": "Node 2.2",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
            ],
            "links": [
              {
                "source": "Node 0",
                "target": "Node 1",
                "distance": 80
              },
              {
                "source": "Node 1",
                "target": "Node 1.0",
                "distance": 50
              },
              {
                "source": "Node 1",
                "target": "Node 1.1",
                "distance": 50
              },
              {
                "source": "Node 1",
                "target": "Node 1.2",
                "distance": 50
              },
              {
                "source": "Node 0",
                "target": "Node 2",
                "distance": 80
              },
              {
                "source": "Node 2",
                "target": "Node 2.0",
                "distance": 50
              },
              {
                "source": "Node 2",
                "target": "Node 2.1",
                "distance": 50
              },
              {
                "source": "Node 2",
                "target": "Node 2.2",
                "distance": 50
              },
            ]
          }  

          const chordd =         [
            [
              756,
              280,
              370,
              786,
              388
            ],
            [
              161,
              853,
              394,
              51,
              33
            ],
            [
              318,
              1834,
              391,
              994,
              294
            ],
            [
              361,
              415,
              445,
              424,
              1939
            ],
            [
              265,
              895,
              339,
              992,
              328
            ]
          ]  
          
          const dmap = [
            {
              "id": "AFG",
              "value": 659788
            },
            {
              "id": "AGO",
              "value": 242152
            },
            {
              "id": "ALB",
              "value": 900201
            },
            {
              "id": "ARE",
              "value": 279376
            },
            {
              "id": "ARG",
              "value": 626164
            },
            {
              "id": "ARM",
              "value": 422370
            },
            {
              "id": "ATA",
              "value": 483257
            },
            {
              "id": "ATF",
              "value": 711345
            },
            {
              "id": "AUT",
              "value": 40733
            },
            {
              "id": "AZE",
              "value": 234404
            },
            {
              "id": "BDI",
              "value": 55264
            },
            {
              "id": "BEL",
              "value": 506598
            },
            {
              "id": "BEN",
              "value": 703536
            },
            {
              "id": "BFA",
              "value": 259673
            },
            {
              "id": "BGD",
              "value": 132169
            },
            {
              "id": "BGR",
              "value": 571290
            },
            {
              "id": "BHS",
              "value": 500630
            },
            {
              "id": "BIH",
              "value": 887627
            },
            {
              "id": "BLR",
              "value": 444028
            },
            {
              "id": "BLZ",
              "value": 999206
            },
            {
              "id": "BOL",
              "value": 89675
            },
            {
              "id": "BRN",
              "value": 707451
            },
            {
              "id": "BTN",
              "value": 451415
            },
            {
              "id": "BWA",
              "value": 166636
            },
            {
              "id": "CAF",
              "value": 815231
            },
            {
              "id": "CAN",
              "value": 681485
            },
            {
              "id": "CHE",
              "value": 767043
            },
            {
              "id": "CHL",
              "value": 5364
            },
            {
              "id": "CHN",
              "value": 550717
            },
            {
              "id": "CIV",
              "value": 210843
            },
            {
              "id": "CMR",
              "value": 125717
            },
            {
              "id": "COG",
              "value": 830619
            },
            {
              "id": "COL",
              "value": 622319
            },
            {
              "id": "CRI",
              "value": 219133
            },
            {
              "id": "CUB",
              "value": 770961
            },
            {
              "id": "-99",
              "value": 31794
            },
            {
              "id": "CYP",
              "value": 260908
            },
            {
              "id": "CZE",
              "value": 46928
            },
            {
              "id": "DEU",
              "value": 972487
            },
            {
              "id": "DJI",
              "value": 995504
            },
            {
              "id": "DNK",
              "value": 320483
            },
            {
              "id": "DOM",
              "value": 71138
            },
            {
              "id": "DZA",
              "value": 634804
            },
            {
              "id": "ECU",
              "value": 362073
            },
            {
              "id": "EGY",
              "value": 304745
            },
            {
              "id": "ERI",
              "value": 906067
            },
            {
              "id": "ESP",
              "value": 21735
            },
            {
              "id": "EST",
              "value": 907725
            },
            {
              "id": "ETH",
              "value": 601100
            },
            {
              "id": "FIN",
              "value": 827637
            },
            {
              "id": "FJI",
              "value": 209230
            },
            {
              "id": "FLK",
              "value": 643658
            },
            {
              "id": "FRA",
              "value": 198701
            },
            {
              "id": "GAB",
              "value": 811550
            },
            {
              "id": "GBR",
              "value": 388676
            },
            {
              "id": "GEO",
              "value": 819866
            },
            {
              "id": "GHA",
              "value": 429105
            },
            {
              "id": "GIN",
              "value": 9464
            },
            {
              "id": "GMB",
              "value": 280997
            },
            {
              "id": "GNB",
              "value": 288504
            },
            {
              "id": "GNQ",
              "value": 79511
            },
            {
              "id": "GRC",
              "value": 341270
            },
            {
              "id": "GTM",
              "value": 826831
            },
            {
              "id": "GUY",
              "value": 121279
            },
            {
              "id": "HND",
              "value": 42365
            },
            {
              "id": "HRV",
              "value": 579447
            },
            {
              "id": "HTI",
              "value": 378491
            },
            {
              "id": "HUN",
              "value": 44827
            },
            {
              "id": "IDN",
              "value": 482295
            },
            {
              "id": "IND",
              "value": 318980
            },
            {
              "id": "IRL",
              "value": 974338
            },
            {
              "id": "IRN",
              "value": 819656
            },
            {
              "id": "IRQ",
              "value": 159916
            },
            {
              "id": "ISL",
              "value": 539241
            },
            {
              "id": "ISR",
              "value": 856237
            },
            {
              "id": "ITA",
              "value": 244017
            },
            {
              "id": "JAM",
              "value": 649728
            },
            {
              "id": "JOR",
              "value": 333274
            },
            {
              "id": "JPN",
              "value": 981054
            },
            {
              "id": "KAZ",
              "value": 795992
            },
            {
              "id": "KEN",
              "value": 700166
            },
            {
              "id": "KGZ",
              "value": 368359
            },
            {
              "id": "KHM",
              "value": 993820
            },
            {
              "id": "OSA",
              "value": 714423
            },
            {
              "id": "KWT",
              "value": 772037
            },
            {
              "id": "LAO",
              "value": 288865
            },
            {
              "id": "LBN",
              "value": 45317
            },
            {
              "id": "LBR",
              "value": 749391
            },
            {
              "id": "LBY",
              "value": 228944
            },
            {
              "id": "LKA",
              "value": 823996
            },
            {
              "id": "LSO",
              "value": 400198
            },
            {
              "id": "LTU",
              "value": 920277
            },
            {
              "id": "LUX",
              "value": 954995
            },
            {
              "id": "LVA",
              "value": 161175
            },
            {
              "id": "MAR",
              "value": 264495
            },
            {
              "id": "MDA",
              "value": 56342
            },
            {
              "id": "MDG",
              "value": 758573
            },
            {
              "id": "MEX",
              "value": 71321
            },
            {
              "id": "MKD",
              "value": 535968
            },
            {
              "id": "MLI",
              "value": 998058
            },
            {
              "id": "MMR",
              "value": 273467
            },
            {
              "id": "MNE",
              "value": 385592
            },
            {
              "id": "MNG",
              "value": 142728
            },
            {
              "id": "MOZ",
              "value": 755671
            },
            {
              "id": "MRT",
              "value": 998745
            },
            {
              "id": "MWI",
              "value": 747710
            },
            {
              "id": "MYS",
              "value": 275835
            },
            {
              "id": "NAM",
              "value": 262796
            },
            {
              "id": "NCL",
              "value": 108296
            },
            {
              "id": "NER",
              "value": 505986
            },
            {
              "id": "NGA",
              "value": 977308
            },
            {
              "id": "NIC",
              "value": 137665
            },
            {
              "id": "NLD",
              "value": 542313
            },
            {
              "id": "NOR",
              "value": 579764
            },
            {
              "id": "NPL",
              "value": 657797
            },
            {
              "id": "NZL",
              "value": 856319
            },
            {
              "id": "OMN",
              "value": 129176
            },
            {
              "id": "PAK",
              "value": 61675
            },
            {
              "id": "PAN",
              "value": 690074
            },
            {
              "id": "PER",
              "value": 220977
            },
            {
              "id": "PHL",
              "value": 816757
            },
            {
              "id": "PNG",
              "value": 646094
            },
            {
              "id": "POL",
              "value": 945580
            },
            {
              "id": "PRI",
              "value": 188993
            },
            {
              "id": "PRT",
              "value": 241319
            },
            {
              "id": "PRY",
              "value": 270857
            },
            {
              "id": "QAT",
              "value": 587597
            },
            {
              "id": "ROU",
              "value": 920155
            },
            {
              "id": "RUS",
              "value": 419103
            },
            {
              "id": "RWA",
              "value": 749523
            },
            {
              "id": "ESH",
              "value": 982477
            },
            {
              "id": "SAU",
              "value": 435628
            },
            {
              "id": "SDN",
              "value": 344721
            },
            {
              "id": "SDS",
              "value": 178267
            },
            {
              "id": "SEN",
              "value": 176801
            },
            {
              "id": "SLB",
              "value": 98743
            },
            {
              "id": "SLE",
              "value": 584295
            },
            {
              "id": "SLV",
              "value": 317579
            },
            {
              "id": "ABV",
              "value": 100109
            },
            {
              "id": "SOM",
              "value": 761672
            },
            {
              "id": "SRB",
              "value": 440203
            },
            {
              "id": "SUR",
              "value": 654301
            },
            {
              "id": "SVK",
              "value": 848453
            },
            {
              "id": "SVN",
              "value": 308409
            },
            {
              "id": "SWZ",
              "value": 997161
            },
            {
              "id": "SYR",
              "value": 905370
            },
            {
              "id": "TCD",
              "value": 481278
            },
            {
              "id": "TGO",
              "value": 821773
            },
            {
              "id": "THA",
              "value": 993579
            },
            {
              "id": "TJK",
              "value": 935132
            },
            {
              "id": "TKM",
              "value": 255921
            },
            {
              "id": "TLS",
              "value": 524378
            },
            {
              "id": "TTO",
              "value": 427108
            },
            {
              "id": "TUN",
              "value": 720064
            },
            {
              "id": "TUR",
              "value": 271665
            },
            {
              "id": "TWN",
              "value": 193043
            },
            {
              "id": "TZA",
              "value": 159662
            },
            {
              "id": "UGA",
              "value": 165526
            },
            {
              "id": "UKR",
              "value": 731726
            },
            {
              "id": "URY",
              "value": 407882
            },
            {
              "id": "USA",
              "value": 354130
            },
            {
              "id": "UZB",
              "value": 279111
            },
            {
              "id": "VEN",
              "value": 431467
            },
            {
              "id": "VNM",
              "value": 507206
            },
            {
              "id": "VUT",
              "value": 571424
            },
            {
              "id": "PSE",
              "value": 458472
            },
            {
              "id": "YEM",
              "value": 684206
            },
            {
              "id": "ZAF",
              "value": 550425
            },
            {
              "id": "ZMB",
              "value": 857009
            },
            {
              "id": "ZWE",
              "value": 601980
            },
            {
              "id": "KOR",
              "value": 984272
            }
          ]
const dfun =[
  {
    "id": "step_sent",
    "value": 88446,
    "label": "Sent"
  },
  {
    "id": "step_viewed",
    "value": 55625,
    "label": "Viewed"
  },
  {
    "id": "step_clicked",
    "value": 49967,
    "label": "Clicked"
  },
  {
    "id": "step_add_to_card",
    "value": 31645,
    "label": "Add To Card"
  },
  {
    "id": "step_purchased",
    "value": 22962,
    "label": "Purchased"
  }
]
const dheat = [
  {
    "id": "Japan",
    "data": [
      {
        "x": "Train",
        "y": 11390
      },
      {
        "x": "Subway",
        "y": 76644
      },
      {
        "x": "Bus",
        "y": 58831
      },
      {
        "x": "Car",
        "y": 58375
      },
      {
        "x": "Boat",
        "y": 25990
      },
      {
        "x": "Moto",
        "y": 66675
      },
      {
        "x": "Moped",
        "y": -50387
      },
      {
        "x": "Bicycle",
        "y": 45745
      },
      {
        "x": "Others",
        "y": 18725
      }
    ]
  },
  {
    "id": "France",
    "data": [
      {
        "x": "Train",
        "y": -76215
      },
      {
        "x": "Subway",
        "y": -69073
      },
      {
        "x": "Bus",
        "y": -3263
      },
      {
        "x": "Car",
        "y": -35509
      },
      {
        "x": "Boat",
        "y": 78630
      },
      {
        "x": "Moto",
        "y": -17985
      },
      {
        "x": "Moped",
        "y": 23569
      },
      {
        "x": "Bicycle",
        "y": 97667
      },
      {
        "x": "Others",
        "y": -79456
      }
    ]
  },
  {
    "id": "US",
    "data": [
      {
        "x": "Train",
        "y": -33215
      },
      {
        "x": "Subway",
        "y": -49349
      },
      {
        "x": "Bus",
        "y": -77058
      },
      {
        "x": "Car",
        "y": -18747
      },
      {
        "x": "Boat",
        "y": 99783
      },
      {
        "x": "Moto",
        "y": 90766
      },
      {
        "x": "Moped",
        "y": 29266
      },
      {
        "x": "Bicycle",
        "y": -87450
      },
      {
        "x": "Others",
        "y": 9379
      }
    ]
  },
  {
    "id": "Germany",
    "data": [
      {
        "x": "Train",
        "y": -66332
      },
      {
        "x": "Subway",
        "y": 72369
      },
      {
        "x": "Bus",
        "y": 22311
      },
      {
        "x": "Car",
        "y": -63074
      },
      {
        "x": "Boat",
        "y": -77718
      },
      {
        "x": "Moto",
        "y": 8085
      },
      {
        "x": "Moped",
        "y": 77193
      },
      {
        "x": "Bicycle",
        "y": 39073
      },
      {
        "x": "Others",
        "y": 3292
      }
    ]
  },
  {
    "id": "Norway",
    "data": [
      {
        "x": "Train",
        "y": 12390
      },
      {
        "x": "Subway",
        "y": -6194
      },
      {
        "x": "Bus",
        "y": -82639
      },
      {
        "x": "Car",
        "y": 86763
      },
      {
        "x": "Boat",
        "y": 81945
      },
      {
        "x": "Moto",
        "y": -88172
      },
      {
        "x": "Moped",
        "y": 59464
      },
      {
        "x": "Bicycle",
        "y": 51254
      },
      {
        "x": "Others",
        "y": -21814
      }
    ]
  },
  {
    "id": "Iceland",
    "data": [
      {
        "x": "Train",
        "y": -56030
      },
      {
        "x": "Subway",
        "y": -47934
      },
      {
        "x": "Bus",
        "y": 72383
      },
      {
        "x": "Car",
        "y": -97322
      },
      {
        "x": "Boat",
        "y": 6377
      },
      {
        "x": "Moto",
        "y": -22337
      },
      {
        "x": "Moped",
        "y": -83894
      },
      {
        "x": "Bicycle",
        "y": -57687
      },
      {
        "x": "Others",
        "y": -35826
      }
    ]
  },
  {
    "id": "UK",
    "data": [
      {
        "x": "Train",
        "y": -17805
      },
      {
        "x": "Subway",
        "y": -48920
      },
      {
        "x": "Bus",
        "y": -66921
      },
      {
        "x": "Car",
        "y": 71653
      },
      {
        "x": "Boat",
        "y": -95883
      },
      {
        "x": "Moto",
        "y": 24555
      },
      {
        "x": "Moped",
        "y": 28251
      },
      {
        "x": "Bicycle",
        "y": 94634
      },
      {
        "x": "Others",
        "y": 14442
      }
    ]
  },
  {
    "id": "Vietnam",
    "data": [
      {
        "x": "Train",
        "y": 29156
      },
      {
        "x": "Subway",
        "y": -6903
      },
      {
        "x": "Bus",
        "y": 697
      },
      {
        "x": "Car",
        "y": 76660
      },
      {
        "x": "Boat",
        "y": 41519
      },
      {
        "x": "Moto",
        "y": 3167
      },
      {
        "x": "Moped",
        "y": -4368
      },
      {
        "x": "Bicycle",
        "y": -4216
      },
      {
        "x": "Others",
        "y": -44336
      }
    ]
  }
]
const dline = [
  {
    "id": "Finance",
    "color": "hsl(302, 70%, 50%)",
    "data": [
      {
        "x": "Jan",
        "y": 202
      },
      {
        "x": "Feb",
        "y": 283
      },
      {
        "x": "Mar",
        "y": 114
      },
      {
        "x": "Aoril",
        "y": 124
      },
      {
        "x": "May",
        "y": 112
      },
      {
        "x": "June",
        "y": 272
      },
      {
        "x": "July",
        "y": 126
      },
      {
        "x": "August",
        "y": 263
      },
      {
        "x": "Sep",
        "y": 236
      },
      {
        "x": "Oct",
        "y": 74
      },
      {
        "x": "Nov",
        "y": 59
      },
      {
        "x": "Dec",
        "y": 281
      }
    ]
  },
  {
    "id": "HR and Admin",
    "color": "hsl(302, 70%, 50%)",
    "data": [
      {
        "x": "Jan",
        "y": 100
      },
      {
        "x": "Feb",
        "y": 183
      },
      {
        "x": "Mar",
        "y": 14
      },
      {
        "x": "Aoril",
        "y": 10
      },
      {
        "x": "May",
        "y": 12
      },
      {
        "x": "June",
        "y": 200
      },
      {
        "x": "July",
        "y": 23
      },
      {
        "x": "August",
        "y": 53
      },
      {
        "x": "Sep",
        "y": 26
      },
      {
        "x": "Oct",
        "y": 34
      },
      {
        "x": "Nov",
        "y": 29
      },
      {
        "x": "Dec",
        "y": 181
      }
    ]
  },
  {
    "id": "Operation",
    "color": "hsl(302, 70%, 50%)",
    "data": [
      {
        "x": "Jan",
        "y": 50
      },
      {
        "x": "Feb",
        "y": 13
      },
      {
        "x": "Mar",
        "y": 4
      },
      {
        "x": "Aoril",
        "y": 50
      },
      {
        "x": "May",
        "y": 16
      },
      {
        "x": "June",
        "y": 50
      },
      {
        "x": "July",
        "y": 13
      },
      {
        "x": "August",
        "y": 59
      },
      {
        "x": "Sep",
        "y": 36
      },
      {
        "x": "Oct",
        "y": 14
      },
      {
        "x": "Nov",
        "y": 19
      },
      {
        "x": "Dec",
        "y": 11
      }
    ]
  },

]
const dlineabsence =  dline ;
      
// const dlineabsence =  GraphData[1]
      
const dmarimekko = [
  {
    "statement": "it's good",
    "participation": 21,
    "stronglyAgree": 24,
    "agree": 13,
    "disagree": 8,
    "stronglyDisagree": 29
  },
  {
    "statement": "it's sweet",
    "participation": 7,
    "stronglyAgree": 15,
    "agree": 25,
    "disagree": 8,
    "stronglyDisagree": 11
  },
  {
    "statement": "it's spicy",
    "participation": 32,
    "stronglyAgree": 28,
    "agree": 17,
    "disagree": 22,
    "stronglyDisagree": 1
  },
  {
    "statement": "worth eating",
    "participation": 15,
    "stronglyAgree": 30,
    "agree": 4,
    "disagree": 32,
    "stronglyDisagree": 1
  },
  {
    "statement": "worth buying",
    "participation": 4,
    "stronglyAgree": 1,
    "agree": 23,
    "disagree": 0,
    "stronglyDisagree": 29
  }
]
const dradar = [
  {
    "taste": "fruity",
    "chardonay": 67,
    "carmenere": 35,
    "syrah": 58
  },
  {
    "taste": "bitter",
    "chardonay": 44,
    "carmenere": 97,
    "syrah": 54
  },
  {
    "taste": "heavy",
    "chardonay": 26,
    "carmenere": 92,
    "syrah": 96
  },
  {
    "taste": "strong",
    "chardonay": 80,
    "carmenere": 89,
    "syrah": 100
  },
  {
    "taste": "sunny",
    "chardonay": 41,
    "carmenere": 28,
    "syrah": 29
  }
]

const dswarm = [
  {
    "id": "0.0",
    "group": "group A",
    "price": 125,
    "volume": 11
  },
  {
    "id": "0.1",
    "group": "group A",
    "price": 57,
    "volume": 18
  },
  {
    "id": "0.2",
    "group": "group A",
    "price": 125,
    "volume": 7
  },
  {
    "id": "0.3",
    "group": "group A",
    "price": 125,
    "volume": 10
  },
  {
    "id": "0.4",
    "group": "group A",
    "price": 356,
    "volume": 19
  },
  {
    "id": "0.5",
    "group": "group A",
    "price": 141,
    "volume": 20
  },
  {
    "id": "0.6",
    "group": "group A",
    "price": 299,
    "volume": 16
  },
  {
    "id": "0.7",
    "group": "group A",
    "price": 158,
    "volume": 15
  },
  {
    "id": "0.8",
    "group": "group A",
    "price": 167,
    "volume": 6
  },
  {
    "id": "0.9",
    "group": "group A",
    "price": 443,
    "volume": 15
  },
  {
    "id": "0.10",
    "group": "group A",
    "price": 145,
    "volume": 18
  },
  {
    "id": "0.11",
    "group": "group A",
    "price": 234,
    "volume": 20
  },
  {
    "id": "0.12",
    "group": "group A",
    "price": 477,
    "volume": 14
  },
  {
    "id": "0.13",
    "group": "group A",
    "price": 412,
    "volume": 9
  },
  {
    "id": "0.14",
    "group": "group A",
    "price": 1,
    "volume": 5
  },
  {
    "id": "0.15",
    "group": "group A",
    "price": 150,
    "volume": 7
  },
  {
    "id": "0.16",
    "group": "group A",
    "price": 267,
    "volume": 6
  },
  {
    "id": "0.17",
    "group": "group A",
    "price": 75,
    "volume": 16
  },
  {
    "id": "0.18",
    "group": "group A",
    "price": 372,
    "volume": 7
  },
  {
    "id": "0.19",
    "group": "group A",
    "price": 7,
    "volume": 5
  },
  {
    "id": "0.20",
    "group": "group A",
    "price": 391,
    "volume": 9
  },
  {
    "id": "0.21",
    "group": "group A",
    "price": 306,
    "volume": 16
  },
  {
    "id": "0.22",
    "group": "group A",
    "price": 86,
    "volume": 5
  },
  {
    "id": "0.23",
    "group": "group A",
    "price": 349,
    "volume": 14
  },
  {
    "id": "0.24",
    "group": "group A",
    "price": 225,
    "volume": 18
  },
  {
    "id": "0.25",
    "group": "group A",
    "price": 190,
    "volume": 6
  },
  {
    "id": "0.26",
    "group": "group A",
    "price": 498,
    "volume": 17
  },
  {
    "id": "0.27",
    "group": "group A",
    "price": 151,
    "volume": 6
  },
  {
    "id": "0.28",
    "group": "group A",
    "price": 177,
    "volume": 9
  },
  {
    "id": "0.29",
    "group": "group A",
    "price": 131,
    "volume": 7
  },
  {
    "id": "0.30",
    "group": "group A",
    "price": 481,
    "volume": 11
  },
  {
    "id": "0.31",
    "group": "group A",
    "price": 281,
    "volume": 13
  },
  {
    "id": "0.32",
    "group": "group A",
    "price": 473,
    "volume": 7
  },
  {
    "id": "0.33",
    "group": "group A",
    "price": 422,
    "volume": 16
  },
  {
    "id": "0.34",
    "group": "group A",
    "price": 117,
    "volume": 13
  },
  {
    "id": "0.35",
    "group": "group A",
    "price": 51,
    "volume": 10
  },
  {
    "id": "0.36",
    "group": "group A",
    "price": 176,
    "volume": 16
  },
  {
    "id": "0.37",
    "group": "group A",
    "price": 412,
    "volume": 5
  },
  {
    "id": "0.38",
    "group": "group A",
    "price": 460,
    "volume": 13
  },
  {
    "id": "0.39",
    "group": "group A",
    "price": 413,
    "volume": 19
  },
  {
    "id": "0.40",
    "group": "group A",
    "price": 128,
    "volume": 6
  },
  {
    "id": "0.41",
    "group": "group A",
    "price": 339,
    "volume": 20
  },
  {
    "id": "0.42",
    "group": "group A",
    "price": 24,
    "volume": 4
  },
  {
    "id": "0.43",
    "group": "group A",
    "price": 189,
    "volume": 12
  },
  {
    "id": "0.44",
    "group": "group A",
    "price": 426,
    "volume": 19
  },
  {
    "id": "0.45",
    "group": "group A",
    "price": 364,
    "volume": 15
  },
  {
    "id": "0.46",
    "group": "group A",
    "price": 364,
    "volume": 13
  },
  {
    "id": "0.47",
    "group": "group A",
    "price": 472,
    "volume": 10
  },
  {
    "id": "0.48",
    "group": "group A",
    "price": 203,
    "volume": 18
  },
  {
    "id": "0.49",
    "group": "group A",
    "price": 62,
    "volume": 14
  },
  {
    "id": "0.50",
    "group": "group A",
    "price": 296,
    "volume": 17
  },
  {
    "id": "0.51",
    "group": "group A",
    "price": 406,
    "volume": 11
  },
  {
    "id": "0.52",
    "group": "group A",
    "price": 34,
    "volume": 14
  },
  {
    "id": "0.53",
    "group": "group A",
    "price": 442,
    "volume": 13
  },
  {
    "id": "1.0",
    "group": "group B",
    "price": 349,
    "volume": 20
  },
  {
    "id": "1.1",
    "group": "group B",
    "price": 262,
    "volume": 4
  },
  {
    "id": "1.2",
    "group": "group B",
    "price": 216,
    "volume": 14
  },
  {
    "id": "1.3",
    "group": "group B",
    "price": 404,
    "volume": 7
  },
  {
    "id": "1.4",
    "group": "group B",
    "price": 435,
    "volume": 10
  },
  {
    "id": "1.5",
    "group": "group B",
    "price": 379,
    "volume": 13
  },
  {
    "id": "1.6",
    "group": "group B",
    "price": 295,
    "volume": 10
  },
  {
    "id": "1.7",
    "group": "group B",
    "price": 472,
    "volume": 6
  },
  {
    "id": "1.8",
    "group": "group B",
    "price": 416,
    "volume": 13
  },
  {
    "id": "1.9",
    "group": "group B",
    "price": 475,
    "volume": 10
  },
  {
    "id": "1.10",
    "group": "group B",
    "price": 200,
    "volume": 4
  },
  {
    "id": "1.11",
    "group": "group B",
    "price": 335,
    "volume": 7
  },
  {
    "id": "1.12",
    "group": "group B",
    "price": 213,
    "volume": 20
  },
  {
    "id": "1.13",
    "group": "group B",
    "price": 399,
    "volume": 10
  },
  {
    "id": "1.14",
    "group": "group B",
    "price": 82,
    "volume": 8
  },
  {
    "id": "1.15",
    "group": "group B",
    "price": 209,
    "volume": 12
  },
  {
    "id": "1.16",
    "group": "group B",
    "price": 359,
    "volume": 11
  },
  {
    "id": "1.17",
    "group": "group B",
    "price": 224,
    "volume": 18
  },
  {
    "id": "1.18",
    "group": "group B",
    "price": 13,
    "volume": 17
  },
  {
    "id": "1.19",
    "group": "group B",
    "price": 84,
    "volume": 10
  },
  {
    "id": "1.20",
    "group": "group B",
    "price": 124,
    "volume": 19
  },
  {
    "id": "1.21",
    "group": "group B",
    "price": 422,
    "volume": 11
  },
  {
    "id": "1.22",
    "group": "group B",
    "price": 354,
    "volume": 9
  },
  {
    "id": "1.23",
    "group": "group B",
    "price": 164,
    "volume": 4
  },
  {
    "id": "1.24",
    "group": "group B",
    "price": 309,
    "volume": 18
  },
  {
    "id": "1.25",
    "group": "group B",
    "price": 110,
    "volume": 8
  },
  {
    "id": "1.26",
    "group": "group B",
    "price": 82,
    "volume": 13
  },
  {
    "id": "1.27",
    "group": "group B",
    "price": 260,
    "volume": 5
  },
  {
    "id": "1.28",
    "group": "group B",
    "price": 355,
    "volume": 13
  },
  {
    "id": "1.29",
    "group": "group B",
    "price": 272,
    "volume": 11
  },
  {
    "id": "1.30",
    "group": "group B",
    "price": 63,
    "volume": 6
  },
  {
    "id": "1.31",
    "group": "group B",
    "price": 398,
    "volume": 7
  },
  {
    "id": "1.32",
    "group": "group B",
    "price": 457,
    "volume": 20
  },
  {
    "id": "1.33",
    "group": "group B",
    "price": 487,
    "volume": 15
  },
  {
    "id": "1.34",
    "group": "group B",
    "price": 269,
    "volume": 13
  },
  {
    "id": "1.35",
    "group": "group B",
    "price": 174,
    "volume": 8
  },
  {
    "id": "1.36",
    "group": "group B",
    "price": 128,
    "volume": 12
  },
  {
    "id": "1.37",
    "group": "group B",
    "price": 208,
    "volume": 6
  },
  {
    "id": "1.38",
    "group": "group B",
    "price": 64,
    "volume": 19
  },
  {
    "id": "1.39",
    "group": "group B",
    "price": 98,
    "volume": 14
  },
  {
    "id": "1.40",
    "group": "group B",
    "price": 226,
    "volume": 6
  },
  {
    "id": "1.41",
    "group": "group B",
    "price": 345,
    "volume": 11
  },
  {
    "id": "1.42",
    "group": "group B",
    "price": 235,
    "volume": 17
  },
  {
    "id": "1.43",
    "group": "group B",
    "price": 86,
    "volume": 11
  },
  {
    "id": "1.44",
    "group": "group B",
    "price": 235,
    "volume": 13
  },
  {
    "id": "1.45",
    "group": "group B",
    "price": 219,
    "volume": 7
  },
  {
    "id": "1.46",
    "group": "group B",
    "price": 316,
    "volume": 16
  },
  {
    "id": "1.47",
    "group": "group B",
    "price": 396,
    "volume": 14
  },
  {
    "id": "1.48",
    "group": "group B",
    "price": 11,
    "volume": 13
  },
  {
    "id": "1.49",
    "group": "group B",
    "price": 238,
    "volume": 18
  },
  {
    "id": "1.50",
    "group": "group B",
    "price": 317,
    "volume": 17
  },
  {
    "id": "1.51",
    "group": "group B",
    "price": 288,
    "volume": 12
  },
  {
    "id": "1.52",
    "group": "group B",
    "price": 363,
    "volume": 14
  },
  {
    "id": "1.53",
    "group": "group B",
    "price": 198,
    "volume": 10
  },
  {
    "id": "1.54",
    "group": "group B",
    "price": 372,
    "volume": 5
  },
  {
    "id": "1.55",
    "group": "group B",
    "price": 49,
    "volume": 17
  },
  {
    "id": "1.56",
    "group": "group B",
    "price": 197,
    "volume": 20
  },
  {
    "id": "1.57",
    "group": "group B",
    "price": 7,
    "volume": 8
  },
  {
    "id": "1.58",
    "group": "group B",
    "price": 429,
    "volume": 10
  },
  {
    "id": "1.59",
    "group": "group B",
    "price": 153,
    "volume": 19
  },
  {
    "id": "1.60",
    "group": "group B",
    "price": 147,
    "volume": 11
  },
  {
    "id": "1.61",
    "group": "group B",
    "price": 19,
    "volume": 16
  },
  {
    "id": "1.62",
    "group": "group B",
    "price": 179,
    "volume": 6
  },
  {
    "id": "1.63",
    "group": "group B",
    "price": 343,
    "volume": 16
  },
  {
    "id": "1.64",
    "group": "group B",
    "price": 197,
    "volume": 10
  },
  {
    "id": "1.65",
    "group": "group B",
    "price": 192,
    "volume": 4
  },
  {
    "id": "1.66",
    "group": "group B",
    "price": 194,
    "volume": 11
  },
  {
    "id": "1.67",
    "group": "group B",
    "price": 219,
    "volume": 7
  },
  {
    "id": "1.68",
    "group": "group B",
    "price": 81,
    "volume": 12
  },
  {
    "id": "1.69",
    "group": "group B",
    "price": 188,
    "volume": 19
  },
  {
    "id": "1.70",
    "group": "group B",
    "price": 185,
    "volume": 16
  },
  {
    "id": "1.71",
    "group": "group B",
    "price": 40,
    "volume": 7
  },
  {
    "id": "1.72",
    "group": "group B",
    "price": 394,
    "volume": 16
  },
  {
    "id": "1.73",
    "group": "group B",
    "price": 492,
    "volume": 10
  },
  {
    "id": "2.0",
    "group": "group C",
    "price": 235,
    "volume": 6
  },
  {
    "id": "2.1",
    "group": "group C",
    "price": 61,
    "volume": 18
  },
  {
    "id": "2.2",
    "group": "group C",
    "price": 299,
    "volume": 15
  },
  {
    "id": "2.3",
    "group": "group C",
    "price": 19,
    "volume": 5
  },
  {
    "id": "2.4",
    "group": "group C",
    "price": 341,
    "volume": 7
  },
  {
    "id": "2.5",
    "group": "group C",
    "price": 134,
    "volume": 8
  },
  {
    "id": "2.6",
    "group": "group C",
    "price": 181,
    "volume": 6
  },
  {
    "id": "2.7",
    "group": "group C",
    "price": 200,
    "volume": 19
  },
  {
    "id": "2.8",
    "group": "group C",
    "price": 183,
    "volume": 5
  },
  {
    "id": "2.9",
    "group": "group C",
    "price": 357,
    "volume": 10
  },
  {
    "id": "2.10",
    "group": "group C",
    "price": 172,
    "volume": 13
  },
  {
    "id": "2.11",
    "group": "group C",
    "price": 452,
    "volume": 4
  },
  {
    "id": "2.12",
    "group": "group C",
    "price": 181,
    "volume": 20
  },
  {
    "id": "2.13",
    "group": "group C",
    "price": 111,
    "volume": 10
  },
  {
    "id": "2.14",
    "group": "group C",
    "price": 62,
    "volume": 18
  },
  {
    "id": "2.15",
    "group": "group C",
    "price": 81,
    "volume": 10
  },
  {
    "id": "2.16",
    "group": "group C",
    "price": 286,
    "volume": 15
  },
  {
    "id": "2.17",
    "group": "group C",
    "price": 339,
    "volume": 14
  },
  {
    "id": "2.18",
    "group": "group C",
    "price": 375,
    "volume": 16
  },
  {
    "id": "2.19",
    "group": "group C",
    "price": 34,
    "volume": 19
  },
  {
    "id": "2.20",
    "group": "group C",
    "price": 7,
    "volume": 20
  },
  {
    "id": "2.21",
    "group": "group C",
    "price": 44,
    "volume": 18
  },
  {
    "id": "2.22",
    "group": "group C",
    "price": 237,
    "volume": 15
  },
  {
    "id": "2.23",
    "group": "group C",
    "price": 364,
    "volume": 8
  },
  {
    "id": "2.24",
    "group": "group C",
    "price": 386,
    "volume": 19
  },
  {
    "id": "2.25",
    "group": "group C",
    "price": 154,
    "volume": 17
  },
  {
    "id": "2.26",
    "group": "group C",
    "price": 55,
    "volume": 9
  },
  {
    "id": "2.27",
    "group": "group C",
    "price": 191,
    "volume": 9
  },
  {
    "id": "2.28",
    "group": "group C",
    "price": 169,
    "volume": 7
  },
  {
    "id": "2.29",
    "group": "group C",
    "price": 224,
    "volume": 10
  },
  {
    "id": "2.30",
    "group": "group C",
    "price": 295,
    "volume": 10
  },
  {
    "id": "2.31",
    "group": "group C",
    "price": 184,
    "volume": 8
  },
  {
    "id": "2.32",
    "group": "group C",
    "price": 423,
    "volume": 8
  },
  {
    "id": "2.33",
    "group": "group C",
    "price": 435,
    "volume": 5
  },
  {
    "id": "2.34",
    "group": "group C",
    "price": 389,
    "volume": 17
  },
  {
    "id": "2.35",
    "group": "group C",
    "price": 457,
    "volume": 19
  },
  {
    "id": "2.36",
    "group": "group C",
    "price": 116,
    "volume": 14
  },
  {
    "id": "2.37",
    "group": "group C",
    "price": 179,
    "volume": 15
  },
  {
    "id": "2.38",
    "group": "group C",
    "price": 457,
    "volume": 20
  },
  {
    "id": "2.39",
    "group": "group C",
    "price": 174,
    "volume": 10
  },
  {
    "id": "2.40",
    "group": "group C",
    "price": 360,
    "volume": 17
  },
  {
    "id": "2.41",
    "group": "group C",
    "price": 198,
    "volume": 5
  },
  {
    "id": "2.42",
    "group": "group C",
    "price": 322,
    "volume": 16
  },
  {
    "id": "2.43",
    "group": "group C",
    "price": 373,
    "volume": 12
  },
  {
    "id": "2.44",
    "group": "group C",
    "price": 168,
    "volume": 18
  },
  {
    "id": "2.45",
    "group": "group C",
    "price": 332,
    "volume": 9
  },
  {
    "id": "2.46",
    "group": "group C",
    "price": 230,
    "volume": 20
  },
  {
    "id": "2.47",
    "group": "group C",
    "price": 445,
    "volume": 10
  },
  {
    "id": "2.48",
    "group": "group C",
    "price": 352,
    "volume": 13
  },
  {
    "id": "2.49",
    "group": "group C",
    "price": 20,
    "volume": 10
  },
  {
    "id": "2.50",
    "group": "group C",
    "price": 233,
    "volume": 14
  },
  {
    "id": "2.51",
    "group": "group C",
    "price": 416,
    "volume": 18
  },
  {
    "id": "2.52",
    "group": "group C",
    "price": 82,
    "volume": 10
  },
  {
    "id": "2.53",
    "group": "group C",
    "price": 445,
    "volume": 18
  },
  {
    "id": "2.54",
    "group": "group C",
    "price": 418,
    "volume": 9
  },
  {
    "id": "2.55",
    "group": "group C",
    "price": 244,
    "volume": 14
  },
  {
    "id": "2.56",
    "group": "group C",
    "price": 427,
    "volume": 19
  },
  {
    "id": "2.57",
    "group": "group C",
    "price": 108,
    "volume": 13
  },
  {
    "id": "2.58",
    "group": "group C",
    "price": 138,
    "volume": 11
  },
  {
    "id": "2.59",
    "group": "group C",
    "price": 281,
    "volume": 7
  },
  {
    "id": "2.60",
    "group": "group C",
    "price": 379,
    "volume": 12
  },
  {
    "id": "2.61",
    "group": "group C",
    "price": 245,
    "volume": 12
  },
  {
    "id": "2.62",
    "group": "group C",
    "price": 35,
    "volume": 11
  },
  {
    "id": "2.63",
    "group": "group C",
    "price": 464,
    "volume": 5
  },
  {
    "id": "2.64",
    "group": "group C",
    "price": 473,
    "volume": 4
  },
  {
    "id": "2.65",
    "group": "group C",
    "price": 103,
    "volume": 17
  },
  {
    "id": "2.66",
    "group": "group C",
    "price": 133,
    "volume": 17
  },
  {
    "id": "2.67",
    "group": "group C",
    "price": 474,
    "volume": 12
  },
  {
    "id": "2.68",
    "group": "group C",
    "price": 374,
    "volume": 20
  },
  {
    "id": "2.69",
    "group": "group C",
    "price": 350,
    "volume": 10
  },
  {
    "id": "2.70",
    "group": "group C",
    "price": 228,
    "volume": 7
  },
  {
    "id": "2.71",
    "group": "group C",
    "price": 67,
    "volume": 15
  },
  {
    "id": "2.72",
    "group": "group C",
    "price": 434,
    "volume": 15
  },
  {
    "id": "2.73",
    "group": "group C",
    "price": 278,
    "volume": 9
  },
  {
    "id": "2.74",
    "group": "group C",
    "price": 47,
    "volume": 20
  }
]
const dscatter = [
  {
    "id": "group A",
    "data": [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 41,
        "y": 63
      },
      {
        "x": 39,
        "y": 67
      },
      {
        "x": 36,
        "y": 5
      },
      {
        "x": 95,
        "y": 20
      },
      {
        "x": 51,
        "y": 115
      },
      {
        "x": 51,
        "y": 17
      },
      {
        "x": 10,
        "y": 116
      },
      {
        "x": 3,
        "y": 16
      },
      {
        "x": 98,
        "y": 91
      },
      {
        "x": 29,
        "y": 97
      },
      {
        "x": 67,
        "y": 70
      },
      {
        "x": 26,
        "y": 71
      },
      {
        "x": 0,
        "y": 34
      },
      {
        "x": 7,
        "y": 42
      },
      {
        "x": 91,
        "y": 42
      },
      {
        "x": 61,
        "y": 53
      },
      {
        "x": 28,
        "y": 55
      },
      {
        "x": 86,
        "y": 62
      },
      {
        "x": 98,
        "y": 117
      },
      {
        "x": 22,
        "y": 105
      },
      {
        "x": 94,
        "y": 35
      },
      {
        "x": 58,
        "y": 41
      },
      {
        "x": 56,
        "y": 95
      },
      {
        "x": 22,
        "y": 32
      },
      {
        "x": 82,
        "y": 94
      },
      {
        "x": 26,
        "y": 47
      },
      {
        "x": 24,
        "y": 37
      },
      {
        "x": 8,
        "y": 87
      },
      {
        "x": 49,
        "y": 25
      },
      {
        "x": 45,
        "y": 72
      },
      {
        "x": 51,
        "y": 35
      },
      {
        "x": 82,
        "y": 2
      },
      {
        "x": 96,
        "y": 17
      },
      {
        "x": 9,
        "y": 13
      },
      {
        "x": 40,
        "y": 50
      },
      {
        "x": 67,
        "y": 107
      },
      {
        "x": 98,
        "y": 17
      },
      {
        "x": 63,
        "y": 73
      },
      {
        "x": 22,
        "y": 72
      },
      {
        "x": 25,
        "y": 25
      },
      {
        "x": 92,
        "y": 66
      },
      {
        "x": 66,
        "y": 10
      },
      {
        "x": 45,
        "y": 81
      },
      {
        "x": 38,
        "y": 82
      },
      {
        "x": 71,
        "y": 38
      },
      {
        "x": 35,
        "y": 98
      },
      {
        "x": 65,
        "y": 112
      },
      {
        "x": 44,
        "y": 74
      },
      {
        "x": 86,
        "y": 15
      }
    ]
  },
  {
    "id": "group B",
    "data": [
      {
        "x": 31,
        "y": 56
      },
      {
        "x": 50,
        "y": 63
      },
      {
        "x": 55,
        "y": 112
      },
      {
        "x": 30,
        "y": 100
      },
      {
        "x": 1,
        "y": 25
      },
      {
        "x": 99,
        "y": 10
      },
      {
        "x": 71,
        "y": 103
      },
      {
        "x": 75,
        "y": 112
      },
      {
        "x": 70,
        "y": 86
      },
      {
        "x": 28,
        "y": 45
      },
      {
        "x": 7,
        "y": 114
      },
      {
        "x": 72,
        "y": 41
      },
      {
        "x": 85,
        "y": 116
      },
      {
        "x": 97,
        "y": 59
      },
      {
        "x": 7,
        "y": 22
      },
      {
        "x": 2,
        "y": 116
      },
      {
        "x": 34,
        "y": 23
      },
      {
        "x": 85,
        "y": 65
      },
      {
        "x": 45,
        "y": 114
      },
      {
        "x": 12,
        "y": 46
      },
      {
        "x": 21,
        "y": 41
      },
      {
        "x": 56,
        "y": 115
      },
      {
        "x": 64,
        "y": 46
      },
      {
        "x": 89,
        "y": 93
      },
      {
        "x": 92,
        "y": 32
      },
      {
        "x": 65,
        "y": 89
      },
      {
        "x": 82,
        "y": 44
      },
      {
        "x": 94,
        "y": 120
      },
      {
        "x": 23,
        "y": 5
      },
      {
        "x": 40,
        "y": 44
      },
      {
        "x": 81,
        "y": 50
      },
      {
        "x": 48,
        "y": 50
      },
      {
        "x": 77,
        "y": 32
      },
      {
        "x": 34,
        "y": 22
      },
      {
        "x": 86,
        "y": 58
      },
      {
        "x": 42,
        "y": 14
      },
      {
        "x": 64,
        "y": 21
      },
      {
        "x": 42,
        "y": 30
      },
      {
        "x": 47,
        "y": 43
      },
      {
        "x": 46,
        "y": 29
      },
      {
        "x": 14,
        "y": 42
      },
      {
        "x": 67,
        "y": 3
      },
      {
        "x": 23,
        "y": 66
      },
      {
        "x": 47,
        "y": 24
      },
      {
        "x": 19,
        "y": 20
      },
      {
        "x": 85,
        "y": 74
      },
      {
        "x": 60,
        "y": 10
      },
      {
        "x": 62,
        "y": 90
      },
      {
        "x": 84,
        "y": 85
      },
      {
        "x": 93,
        "y": 16
      }
    ]
  },
  {
    "id": "group C",
    "data": [
      {
        "x": 65,
        "y": 48
      },
      {
        "x": 69,
        "y": 28
      },
      {
        "x": 31,
        "y": 31
      },
      {
        "x": 94,
        "y": 3
      },
      {
        "x": 8,
        "y": 66
      },
      {
        "x": 53,
        "y": 112
      },
      {
        "x": 2,
        "y": 106
      },
      {
        "x": 100,
        "y": 61
      },
      {
        "x": 25,
        "y": 108
      },
      {
        "x": 56,
        "y": 51
      },
      {
        "x": 21,
        "y": 21
      },
      {
        "x": 16,
        "y": 67
      },
      {
        "x": 96,
        "y": 45
      },
      {
        "x": 42,
        "y": 51
      },
      {
        "x": 93,
        "y": 24
      },
      {
        "x": 72,
        "y": 17
      },
      {
        "x": 18,
        "y": 114
      },
      {
        "x": 14,
        "y": 36
      },
      {
        "x": 31,
        "y": 79
      },
      {
        "x": 68,
        "y": 118
      },
      {
        "x": 62,
        "y": 116
      },
      {
        "x": 99,
        "y": 28
      },
      {
        "x": 31,
        "y": 52
      },
      {
        "x": 60,
        "y": 45
      },
      {
        "x": 59,
        "y": 29
      },
      {
        "x": 35,
        "y": 56
      },
      {
        "x": 76,
        "y": 3
      },
      {
        "x": 44,
        "y": 39
      },
      {
        "x": 50,
        "y": 62
      },
      {
        "x": 55,
        "y": 112
      },
      {
        "x": 17,
        "y": 3
      },
      {
        "x": 93,
        "y": 82
      },
      {
        "x": 75,
        "y": 52
      },
      {
        "x": 18,
        "y": 16
      },
      {
        "x": 29,
        "y": 80
      },
      {
        "x": 44,
        "y": 91
      },
      {
        "x": 80,
        "y": 97
      },
      {
        "x": 99,
        "y": 37
      },
      {
        "x": 46,
        "y": 46
      },
      {
        "x": 65,
        "y": 113
      },
      {
        "x": 86,
        "y": 48
      },
      {
        "x": 100,
        "y": 89
      },
      {
        "x": 2,
        "y": 43
      },
      {
        "x": 28,
        "y": 15
      },
      {
        "x": 32,
        "y": 81
      },
      {
        "x": 52,
        "y": 36
      },
      {
        "x": 75,
        "y": 16
      },
      {
        "x": 47,
        "y": 102
      },
      {
        "x": 53,
        "y": 83
      },
      {
        "x": 39,
        "y": 65
      }
    ]
  },
  {
    "id": "group D",
    "data": [
      {
        "x": 50,
        "y": 68
      },
      {
        "x": 25,
        "y": 14
      },
      {
        "x": 40,
        "y": 113
      },
      {
        "x": 9,
        "y": 67
      },
      {
        "x": 93,
        "y": 104
      },
      {
        "x": 40,
        "y": 106
      },
      {
        "x": 49,
        "y": 16
      },
      {
        "x": 32,
        "y": 3
      },
      {
        "x": 81,
        "y": 32
      },
      {
        "x": 52,
        "y": 26
      },
      {
        "x": 72,
        "y": 73
      },
      {
        "x": 85,
        "y": 17
      },
      {
        "x": 76,
        "y": 77
      },
      {
        "x": 83,
        "y": 23
      },
      {
        "x": 26,
        "y": 113
      },
      {
        "x": 5,
        "y": 80
      },
      {
        "x": 59,
        "y": 34
      },
      {
        "x": 56,
        "y": 41
      },
      {
        "x": 51,
        "y": 26
      },
      {
        "x": 39,
        "y": 13
      },
      {
        "x": 55,
        "y": 43
      },
      {
        "x": 90,
        "y": 41
      },
      {
        "x": 95,
        "y": 79
      },
      {
        "x": 40,
        "y": 0
      },
      {
        "x": 65,
        "y": 58
      },
      {
        "x": 15,
        "y": 73
      },
      {
        "x": 25,
        "y": 70
      },
      {
        "x": 60,
        "y": 70
      },
      {
        "x": 23,
        "y": 102
      },
      {
        "x": 92,
        "y": 36
      },
      {
        "x": 19,
        "y": 48
      },
      {
        "x": 95,
        "y": 7
      },
      {
        "x": 72,
        "y": 79
      },
      {
        "x": 85,
        "y": 105
      },
      {
        "x": 78,
        "y": 111
      },
      {
        "x": 15,
        "y": 43
      },
      {
        "x": 84,
        "y": 14
      },
      {
        "x": 38,
        "y": 44
      },
      {
        "x": 61,
        "y": 112
      },
      {
        "x": 27,
        "y": 12
      },
      {
        "x": 3,
        "y": 113
      },
      {
        "x": 4,
        "y": 8
      },
      {
        "x": 94,
        "y": 104
      },
      {
        "x": 90,
        "y": 101
      },
      {
        "x": 80,
        "y": 114
      },
      {
        "x": 14,
        "y": 58
      },
      {
        "x": 93,
        "y": 100
      },
      {
        "x": 19,
        "y": 96
      },
      {
        "x": 55,
        "y": 29
      },
      {
        "x": 8,
        "y": 108
      }
    ]
  },
  {
    "id": "group E",
    "data": [
      {
        "x": 84,
        "y": 72
      },
      {
        "x": 2,
        "y": 113
      },
      {
        "x": 51,
        "y": 83
      },
      {
        "x": 69,
        "y": 54
      },
      {
        "x": 44,
        "y": 31
      },
      {
        "x": 28,
        "y": 36
      },
      {
        "x": 73,
        "y": 64
      },
      {
        "x": 80,
        "y": 97
      },
      {
        "x": 21,
        "y": 41
      },
      {
        "x": 40,
        "y": 117
      },
      {
        "x": 49,
        "y": 65
      },
      {
        "x": 4,
        "y": 20
      },
      {
        "x": 80,
        "y": 66
      },
      {
        "x": 4,
        "y": 115
      },
      {
        "x": 52,
        "y": 24
      },
      {
        "x": 60,
        "y": 25
      },
      {
        "x": 53,
        "y": 93
      },
      {
        "x": 2,
        "y": 52
      },
      {
        "x": 2,
        "y": 28
      },
      {
        "x": 92,
        "y": 60
      },
      {
        "x": 4,
        "y": 34
      },
      {
        "x": 57,
        "y": 117
      },
      {
        "x": 8,
        "y": 112
      },
      {
        "x": 86,
        "y": 22
      },
      {
        "x": 24,
        "y": 108
      },
      {
        "x": 30,
        "y": 18
      },
      {
        "x": 5,
        "y": 112
      },
      {
        "x": 95,
        "y": 21
      },
      {
        "x": 84,
        "y": 50
      },
      {
        "x": 78,
        "y": 71
      },
      {
        "x": 3,
        "y": 75
      },
      {
        "x": 31,
        "y": 110
      },
      {
        "x": 99,
        "y": 13
      },
      {
        "x": 16,
        "y": 71
      },
      {
        "x": 45,
        "y": 103
      },
      {
        "x": 34,
        "y": 71
      },
      {
        "x": 32,
        "y": 41
      },
      {
        "x": 55,
        "y": 85
      },
      {
        "x": 11,
        "y": 46
      },
      {
        "x": 26,
        "y": 45
      },
      {
        "x": 93,
        "y": 85
      },
      {
        "x": 14,
        "y": 42
      },
      {
        "x": 98,
        "y": 94
      },
      {
        "x": 1,
        "y": 64
      },
      {
        "x": 4,
        "y": 109
      },
      {
        "x": 61,
        "y": 118
      },
      {
        "x": 76,
        "y": 80
      },
      {
        "x": 88,
        "y": 2
      },
      {
        "x": 64,
        "y": 65
      },
      {
        "x": 46,
        "y": 26
      }
    ]
  }
]
const dcircle = {
  "name": "nivo",
  "color": "hsl(205, 70%, 50%)",
  "children": [
    {
      "name": "viz",
      "color": "hsl(86, 70%, 50%)",
      "children": [
        {
          "name": "stack",
          "color": "hsl(85, 70%, 50%)",
          "children": [
            {
              "name": "cchart",
              "color": "hsl(90, 70%, 50%)",
              "loc": 32060
            },
            {
              "name": "xAxis",
              "color": "hsl(245, 70%, 50%)",
              "loc": 132952
            },
            {
              "name": "yAxis",
              "color": "hsl(176, 70%, 50%)",
              "loc": 33044
            },
            {
              "name": "layers",
              "color": "hsl(214, 70%, 50%)",
              "loc": 76373
            }
          ]
        },
        {
          "name": "ppie",
          "color": "hsl(49, 70%, 50%)",
          "children": [
            {
              "name": "chart",
              "color": "hsl(353, 70%, 50%)",
              "children": [
                {
                  "name": "pie",
                  "color": "hsl(156, 70%, 50%)",
                  "children": [
                    {
                      "name": "outline",
                      "color": "hsl(11, 70%, 50%)",
                      "loc": 77128
                    },
                    {
                      "name": "slices",
                      "color": "hsl(170, 70%, 50%)",
                      "loc": 88830
                    },
                    {
                      "name": "bbox",
                      "color": "hsl(340, 70%, 50%)",
                      "loc": 104786
                    }
                  ]
                },
                {
                  "name": "donut",
                  "color": "hsl(348, 70%, 50%)",
                  "loc": 169502
                },
                {
                  "name": "gauge",
                  "color": "hsl(104, 70%, 50%)",
                  "loc": 118353
                }
              ]
            },
            {
              "name": "legends",
              "color": "hsl(223, 70%, 50%)",
              "loc": 125772
            }
          ]
        }
      ]
    },
    {
      "name": "colors",
      "color": "hsl(215, 70%, 50%)",
      "children": [
        {
          "name": "rgb",
          "color": "hsl(49, 70%, 50%)",
          "loc": 163418
        },
        {
          "name": "hsl",
          "color": "hsl(272, 70%, 50%)",
          "loc": 33537
        }
      ]
    },
    {
      "name": "utils",
      "color": "hsl(300, 70%, 50%)",
      "children": [
        {
          "name": "randomize",
          "color": "hsl(139, 70%, 50%)",
          "loc": 173176
        },
        {
          "name": "resetClock",
          "color": "hsl(33, 70%, 50%)",
          "loc": 26389
        },
        {
          "name": "noop",
          "color": "hsl(218, 70%, 50%)",
          "loc": 35165
        },
        {
          "name": "tick",
          "color": "hsl(197, 70%, 50%)",
          "loc": 67121
        },
        {
          "name": "forceGC",
          "color": "hsl(88, 70%, 50%)",
          "loc": 15883
        },
        {
          "name": "stackTrace",
          "color": "hsl(121, 70%, 50%)",
          "loc": 28403
        },
        {
          "name": "dbg",
          "color": "hsl(162, 70%, 50%)",
          "loc": 36991
        }
      ]
    },
    {
      "name": "generators",
      "color": "hsl(37, 70%, 50%)",
      "children": [
        {
          "name": "address",
          "color": "hsl(12, 70%, 50%)",
          "loc": 148835
        },
        {
          "name": "city",
          "color": "hsl(157, 70%, 50%)",
          "loc": 135362
        },
        {
          "name": "animal",
          "color": "hsl(129, 70%, 50%)",
          "loc": 182542
        },
        {
          "name": "movie",
          "color": "hsl(271, 70%, 50%)",
          "loc": 28368
        },
        {
          "name": "user",
          "color": "hsl(150, 70%, 50%)",
          "loc": 73129
        }
      ]
    },
    {
      "name": "set",
      "color": "hsl(139, 70%, 50%)",
      "children": [
        {
          "name": "clone",
          "color": "hsl(296, 70%, 50%)",
          "loc": 144014
        },
        {
          "name": "intersect",
          "color": "hsl(266, 70%, 50%)",
          "loc": 80884
        },
        {
          "name": "merge",
          "color": "hsl(262, 70%, 50%)",
          "loc": 198937
        },
        {
          "name": "reverse",
          "color": "hsl(127, 70%, 50%)",
          "loc": 131116
        },
        {
          "name": "toArray",
          "color": "hsl(304, 70%, 50%)",
          "loc": 67829
        },
        {
          "name": "toObject",
          "color": "hsl(85, 70%, 50%)",
          "loc": 107928
        },
        {
          "name": "fromCSV",
          "color": "hsl(193, 70%, 50%)",
          "loc": 91156
        },
        {
          "name": "slice",
          "color": "hsl(183, 70%, 50%)",
          "loc": 100074
        },
        {
          "name": "append",
          "color": "hsl(102, 70%, 50%)",
          "loc": 28553
        },
        {
          "name": "prepend",
          "color": "hsl(77, 70%, 50%)",
          "loc": 136248
        },
        {
          "name": "shuffle",
          "color": "hsl(158, 70%, 50%)",
          "loc": 136943
        },
        {
          "name": "pick",
          "color": "hsl(102, 70%, 50%)",
          "loc": 29547
        },
        {
          "name": "plouc",
          "color": "hsl(45, 70%, 50%)",
          "loc": 128694
        }
      ]
    },
    {
      "name": "text",
      "color": "hsl(260, 70%, 50%)",
      "children": [
        {
          "name": "trim",
          "color": "hsl(103, 70%, 50%)",
          "loc": 123642
        },
        {
          "name": "slugify",
          "color": "hsl(207, 70%, 50%)",
          "loc": 80794
        },
        {
          "name": "snakeCase",
          "color": "hsl(244, 70%, 50%)",
          "loc": 138085
        },
        {
          "name": "camelCase",
          "color": "hsl(154, 70%, 50%)",
          "loc": 13409
        },
        {
          "name": "repeat",
          "color": "hsl(102, 70%, 50%)",
          "loc": 21927
        },
        {
          "name": "padLeft",
          "color": "hsl(250, 70%, 50%)",
          "loc": 145058
        },
        {
          "name": "padRight",
          "color": "hsl(6, 70%, 50%)",
          "loc": 62143
        },
        {
          "name": "sanitize",
          "color": "hsl(278, 70%, 50%)",
          "loc": 163980
        },
        {
          "name": "ploucify",
          "color": "hsl(199, 70%, 50%)",
          "loc": 84197
        }
      ]
    },
    {
      "name": "misc",
      "color": "hsl(207, 70%, 50%)",
      "children": [
        {
          "name": "greetings",
          "color": "hsl(325, 70%, 50%)",
          "children": [
            {
              "name": "hey",
              "color": "hsl(309, 70%, 50%)",
              "loc": 96570
            },
            {
              "name": "HOWDY",
              "color": "hsl(306, 70%, 50%)",
              "loc": 74325
            },
            {
              "name": "aloha",
              "color": "hsl(154, 70%, 50%)",
              "loc": 159080
            },
            {
              "name": "AHOY",
              "color": "hsl(315, 70%, 50%)",
              "loc": 166942
            }
          ]
        },
        {
          "name": "other",
          "color": "hsl(271, 70%, 50%)",
          "loc": 196538
        },
        {
          "name": "path",
          "color": "hsl(99, 70%, 50%)",
          "children": [
            {
              "name": "pathA",
              "color": "hsl(163, 70%, 50%)",
              "loc": 19235
            },
            {
              "name": "pathB",
              "color": "hsl(238, 70%, 50%)",
              "children": [
                {
                  "name": "pathB1",
                  "color": "hsl(113, 70%, 50%)",
                  "loc": 80685
                },
                {
                  "name": "pathB2",
                  "color": "hsl(328, 70%, 50%)",
                  "loc": 187182
                },
                {
                  "name": "pathB3",
                  "color": "hsl(184, 70%, 50%)",
                  "loc": 32469
                },
                {
                  "name": "pathB4",
                  "color": "hsl(123, 70%, 50%)",
                  "loc": 107220
                }
              ]
            },
            {
              "name": "pathC",
              "color": "hsl(153, 70%, 50%)",
              "children": [
                {
                  "name": "pathC1",
                  "color": "hsl(59, 70%, 50%)",
                  "loc": 47461
                },
                {
                  "name": "pathC2",
                  "color": "hsl(20, 70%, 50%)",
                  "loc": 111273
                },
                {
                  "name": "pathC3",
                  "color": "hsl(146, 70%, 50%)",
                  "loc": 32540
                },
                {
                  "name": "pathC4",
                  "color": "hsl(292, 70%, 50%)",
                  "loc": 144079
                },
                {
                  "name": "pathC5",
                  "color": "hsl(85, 70%, 50%)",
                  "loc": 7406
                },
                {
                  "name": "pathC6",
                  "color": "hsl(248, 70%, 50%)",
                  "loc": 81238
                },
                {
                  "name": "pathC7",
                  "color": "hsl(214, 70%, 50%)",
                  "loc": 127166
                },
                {
                  "name": "pathC8",
                  "color": "hsl(104, 70%, 50%)",
                  "loc": 73271
                },
                {
                  "name": "pathC9",
                  "color": "hsl(335, 70%, 50%)",
                  "loc": 175156
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}


const dcircle1 = {
  "name": "199",
  "color": "hsl(210, 70%, 50%)",
  "children": [
    {
      "name": "18",
      "color": "hsl(156, 70%, 50%)",
      "children": [
        {
          "children": [
            {
              "name": "4",
              "color": "hsl(250, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "39",
              "color": "hsl(96, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "48",
              "color": "hsl(184, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "57",
              "color": "hsl(172, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "62",
              "color": "hsl(144, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "210",
              "color": "hsl(176, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "214",
              "color": "hsl(126, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "215",
              "color": "hsl(200, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45002",
              "color": "hsl(244, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45003",
              "color": "hsl(248, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45005",
              "color": "hsl(240, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45006",
              "color": "hsl(238, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45008",
              "color": "hsl(236, 70%, 50%)",
              "loc": "4322"
            }
          ]
        },
        {
          "children": []
        },
        {
          "children": [
            {
              "name": "72",
              "color": "hsl(80, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "75",
              "color": "hsl(102, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "100",
              "color": "hsl(118, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "134",
              "color": "hsl(136, 70%, 50%)",
              "loc": "4322"
            }
          ]
        }
      ]
    },
    {
      "name": "19",
      "color": "hsl(210, 70%, 50%)",
      "children": [
        {
          "children": [
            {
              "name": "225",
              "color": "hsl(214, 70%, 50%)",
              "loc": "4322"
            }
          ]
        },
        {
          "children": [
            {
              "name": "130",
              "color": "hsl(208, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "185",
              "color": "hsl(206, 70%, 50%)",
              "loc": "4322"
            }
          ]
        },
        {
          "children": [
            {
              "name": "135",
              "color": "hsl(364, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "152",
              "color": "hsl(354, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "175",
              "color": "hsl(362, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "191",
              "color": "hsl(360, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "212",
              "color": "hsl(302, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "216",
              "color": "hsl(356, 70%, 50%)",
              "loc": "4322"
            }
          ]
        }
      ]
    },
    {
      "name": "50",
      "color": "hsl(150, 70%, 50%)",
      "children": [
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        }
      ]
    },
    {
      "name": "209",
      "color": "hsl(46, 70%, 50%)",
      "children": [
        {
          "children": [
            {
              "name": "9",
              "color": "hsl(220, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "16",
              "color": "hsl(48, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "149",
              "color": "hsl(256, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "180",
              "color": "hsl(34, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "201",
              "color": "hsl(202, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "222",
              "color": "hsl(160, 70%, 50%)",
              "loc": "4322"
            }
          ]
        }
      ]
    },
    {
      "name": "219",
      "color": "hsl(338, 70%, 50%)",
      "children": [
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        }
      ]
    }
  ]
}


          const MyResponsiveNetwork = ({ data1 /* see data tab */ }) => (
            <ResponsiveNetwork
          //  height={800}
          //  width={700}
                data={data1}
             //   margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                linkDistance={function(e){return e.distance}}
                centeringStrength={0.2}
                repulsivity={58}
                iterations={1000}
                nodeSize={function(n){return n.size}}
                activeNodeSize={function(n){return 3.5*n.size}}
                nodeColor={function(e){return e.color}}
                nodeBorderWidth={1}
                animate={true}
                nodeBorderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.8
                        ]
                    ]
                }}
                linkThickness={function(n){return 2+2*n.target.data.height}}
                linkBlendMode="multiply"
                motionConfig="wobbly"
                label={data1=> data1.nodes.id}
            />
        )        

        // head count display calculation start
        


        // make sure parent container have a defined height when using
        // responsive component, otherwise height will be 0 and
        // no chart will be rendered.
        // website examples showcase many properties,
        // you'll often use just a few of them.
        const MyResponsiveAreaBump = ({ data /* see data tab */ }) => (
            <ResponsiveAreaBump
             height={290}
             width={495}
                data={data}
                margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
                spacing={8}
                colors={{ scheme: 'nivo' }}
                blendMode="multiply"
                defs={[
                    {
                        id: 'dots',
                        type: 'patternDots',
                        background: 'inherit',
                        color: '#38bcb2',
                        size: 4,
                        padding: 1,
                        stagger: true
                    },
                    {
                        id: 'lines',
                        type: 'patternLines',
                        background: 'inherit',
                        color: '#eed312',
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10
                    }
                ]}
                fill={[
                    {
                        match: {
                            id: 'CoffeeScript'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'TypeScript'
                        },
                        id: 'lines'
                    }
                ]}
                startLabel="id"
                endLabel="id"
                axisTop={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Year',
                    legendPosition: 'middle',
                    legendOffset: -36
                }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Year',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
            />
        )        

        const MyResponsiveBump = ({ data /* see data tab */ }) => (
            <ResponsiveBump
            height={290}
            width={490}
                data={data}
                colors={{ scheme: 'nivo' }}
                lineWidth={3}
                activeLineWidth={3}
                inactiveLineWidth={1}
                inactiveOpacity={0.15}
                startLabelPadding={30}
                inactivePointSize={0}
                startLabel={'true'}
                pointColor={{ theme: 'background' }}
                pointBorderWidth={2}
                activePointBorderWidth={3}
                pointBorderColor={{ from: 'serie.color' }}
                axisTop={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 27,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: -36
                }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
                axisLeft={null}
                margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
                axisRight={null}
            />
        )
        
   
        const MyResponsiveBar = ({ data /* see data tab */ }) => {
          return (
            <ResponsiveBar 
              data={data}
              keys={["degress"]}
              indexBy="day"
              margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
              padding={0.4}
              valueScale={{ type: "linear" }}
              animate={true}
              enableLabel={false}
              axisTop={null}
              axisRight={null}
              axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "degrees",
                legendPosition: "middle",
                legendOffset: -40
              }}
            />
          );
      };
        
        const MyResponsivePie = ({ data /* see data tab */ }) => (
            <ResponsivePie
            height={290}
            width={390}
                data={data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.6}
                padAngle={1.8}
                cornerRadius={8}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.2
                        ]
                    ]
                }}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={3}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.2
                        ]
                    ]
                }}
                defs={[
                    {
                        id: 'dots',
                        type: 'patternDots',
                        background: 'inherit',
                        color: 'rgba(255, 255, 255, 0.3)',
                        size: 4,
                        padding: 1,
                        stagger: true
                    },
                    {
                        id: 'lines',
                        type: 'patternLines',
                        background: 'inherit',
                        color: 'rgba(255, 255, 255, 0.3)',
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10
                    }
                ]}
                fill={[
                    {
                        match: {
                            id: 'ruby'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'c'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'go'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'python'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'scala'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'lisp'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'elixir'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'javascript'
                        },
                        id: 'lines'
                    }
                ]}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: 56,
                        itemsSpacing: 0,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        )

        const MyResponsiveChord = ({ data /* see data tab */ }) => (
            <ResponsiveChord
            height={290}
            width={390}
                data={data}

                keys={[ 'John', 'Raoul', 'Jane', 'Marcel', 'Ibrahim' ]}
                margin={{ top: 60, right: 60, bottom: 90, left: 70 }}
                valueFormat=".2f"
                padAngle={0.02}
                innerRadiusRatio={0.96}
                innerRadiusOffset={0.02}
                inactiveArcOpacity={0.25}
                arcBorderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.6
                        ]
                    ]
                }}
                activeRibbonOpacity={0.75}
                inactiveRibbonOpacity={0.25}
                ribbonBorderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.6
                        ]
                    ]
                }}
                labelRotation={-90}
                labelTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1
                        ]
                    ]
                }}
                colors={{ scheme: 'category10' }}
                motionConfig="stiff"
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: 70,
                        itemWidth: 80,
                        itemHeight: 14,
                        itemsSpacing: 0,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        symbolSize: 12,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        )

        const MyResponsiveChoropleth = ({ data /* see data tab */ }) => (
            <ResponsiveChoropleth
                data={data}
              //  features={countries.features}
                height={290}
                width={390}
                margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                colors="nivo"
                domain={[ 0, 1000000 ]}
                unknownColor="#666666"
                label="properties.name"
                valueFormat=".2s"
                projectionTranslation={[ 0.5, 0.5 ]}
                projectionRotation={[ 0, 0, 0 ]}
                enableGraticule={true}
                graticuleLineColor="#dddddd"
                borderWidth={0.5}
                borderColor="#152538"
                defs={[
                    {
                        id: 'dots',
                        type: 'patternDots',
                        background: 'inherit',
                        color: '#38bcb2',
                        size: 4,
                        padding: 1,
                        stagger: true
                    },
                    {
                        id: 'lines',
                        type: 'patternLines',
                        background: 'inherit',
                        color: '#eed312',
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10
                    },
                    {
                        id: 'gradient',
                        type: 'linearGradient',
                        colors: [
                            {
                                offset: 0,
                                color: '#000'
                            },
                            {
                                offset: 100,
                                color: 'inherit'
                            }
                        ]
                    }
                ]}
                fill={[
                    {
                        match: {
                            id: 'CAN'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'CHN'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'ATA'
                        },
                        id: 'gradient'
                    }
                ]}
                legends={[
                    {
                        anchor: 'bottom-left',
                        direction: 'column',
                        justify: true,
                        translateX: 20,
                        translateY: -100,
                        itemsSpacing: 0,
                        itemWidth: 94,
                        itemHeight: 18,
                        itemDirection: 'left-to-right',
                        itemTextColor: '#444444',
                        itemOpacity: 0.85,
                        symbolSize: 18,
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000000',
                                    itemOpacity: 1
                                }
                            }
                        ]
                    }
                ]}
            />
        )
        const MyResponsiveFunnel = ({ data /* see data tab */ }) => (
          <ResponsiveFunnel
          height={290}
          width={390}
              data={data}
              margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
              valueFormat=">-.4s"
              colors={{ scheme: 'spectral' }}
              borderWidth={20}
              labelColor={{
                  from: 'color',
                  modifiers: [
                      [
                          'darker',
                          3
                      ]
                  ]
              }}
              beforeSeparatorLength={100}
              beforeSeparatorOffset={20}
              afterSeparatorLength={100}
              afterSeparatorOffset={20}
              currentPartSizeExtension={10}
              currentBorderWidth={40}
              motionConfig="wobbly"
          />
      )
        const MyResponsiveGeoMap = ({ data /* see data tab */ })  => (
            <ResponsiveChoropleth
            data={data}
               features={[]}
                margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                projectionTranslation={[ 0.5, 0.5 ]}
                projectionRotation={[ 0, 0, 0 ]}
                fillColor="#eeeeee"
                borderWidth={0.5}
                borderColor="#333333"
                enableGraticule={true}
                graticuleLineColor="#666666"
            />
        )
      //   const MyResponsiveHeatMap = ({ data /* see data tab */ }) => (
      //     <ResponsiveHeatMap
      //     height={290}
      //     width={490}
      //         data={data}
      //         margin={{ top: 60, right: 90, bottom: 60, left: 90 }}
      //         valueFormat=">-.2s"
      //         axisTop={{
      //             tickSize: 5,
      //             tickPadding: 5,
      //             tickRotation: -90,
      //             legend: '',
      //             legendOffset: 46
      //         }}
      //         axisRight={{
      //             tickSize: 5,
      //             tickPadding: 5,
      //             tickRotation: 0,
      //             legend: 'country',
      //             legendPosition: 'middle',
      //             legendOffset: 70
      //         }}
      //         axisLeft={{
      //             tickSize: 5,
      //             tickPadding: 5,
      //             tickRotation: 0,
      //             legend: 'country',
      //             legendPosition: 'middle',
      //             legendOffset: -72
      //         }}
      //         colors={{
      //             type: 'diverging',
      //             scheme: 'red_yellow_blue',
      //             divergeAt: 0.5,
      //             minValue: -100000,
      //             maxValue: 100000
      //         }}
      //         emptyColor="#555555"
      //         legends={[
      //             {
      //                 anchor: 'bottom',
      //                 translateX: 0,
      //                 translateY: 30,
      //                 length: 400,
      //                 thickness: 8,
      //                 direction: 'row',
      //                 tickPosition: 'after',
      //                 tickSize: 3,
      //                 tickSpacing: 4,
      //                 tickOverlap: false,
      //                 tickFormat: '>-.2s',
      //                 title: 'Value →',
      //                 titleAlign: 'start',
      //                 titleOffset: 4
      //             }
      //         ]}
      //     />
      // )

    //   const MyResponsiveLine = ({ data /* see data tab */ }) => (
    //     <ResponsiveLine
    //         data={data}
    //         height={290}
    //         width={790}
    //         animate
    //         curve="monotoneX"
    //         enableArea
    //         enableSlices="x"
    //         fill={[
    //           {
    //             id: 'gradientA',
    //             match: '*'
    //           }
    //         ]}
    //         margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
    //         xScale={{ type: 'point' }}
    //         yScale={{
    //             type: 'linear',
    //             min: 'auto',
    //             max: 'auto',
    //             stacked: true,
    //             reverse: false
    //         }}
    //         yFormat=" >-.2f"
    //         axisTop={null}
    //         axisRight={null}
    //         axisBottom={{
    //             tickSize: 5,
    //             tickPadding: 5,
    //             tickRotation: 0,
    //             legend: 'Months',
    //             legendOffset: 36,
    //             legendPosition: 'middle'
    //         }}
    //         axisLeft={{
    //             tickSize: 5,
    //             tickPadding: 5,
    //             tickRotation: 0,
    //             legend: 'count',
    //             legendOffset: -40,
    //             legendPosition: 'middle'
    //         }}
    //         pointSize={10}
    //         pointColor={{ theme: 'background' }}
    //         pointBorderWidth={2}
    //         pointBorderColor={{ from: 'serieColor' }}
    //         pointLabelYOffset={-12}
    //         useMesh={true}
    //         legends={[
    //             {
    //                 anchor: 'bottom-right',
    //                 direction: 'column',
    //                 justify: false,
    //                 translateX: 100,
    //                 translateY: 0,
    //                 itemsSpacing: 0,
    //                 itemDirection: 'left-to-right',
    //                 itemWidth: 80,
    //                 itemHeight: 20,
    //                 itemOpacity: 0.75,
    //                 symbolSize: 12,
    //                 symbolShape: 'circle',
    //                 symbolBorderColor: 'rgba(0, 0, 0, .5)',
    //                 effects: [
    //                     {
    //                         on: 'hover',
    //                         style: {
    //                             itemBackground: 'rgba(0, 0, 0, .03)',
    //                             itemOpacity: 1
    //                         }
    //                     }
    //                 ]
    //             }
    //         ]}
    //     />
    // )

    const MyResponsiveMarimekko = ({ data /* see data tab */ }) => (
      <ResponsiveMarimekko
          data={data}
          height={290}
          width={450}
          id="statement"
          value="participation"
          dimensions={[
              {
                  id: 'disagree strongly',
                  value: 'stronglyDisagree'
              },
              {
                  id: 'disagree',
                  value: 'disagree'
              },
              {
                  id: 'agree',
                  value: 'agree'
              },
              {
                  id: 'agree strongly',
                  value: 'stronglyAgree'
              }
          ]}
          innerPadding={9}
          axisTop={null}
          axisRight={{
              orient: 'right',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: '',
              legendOffset: 0
          }}
          axisBottom={{
              orient: 'bottom',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'participation',
              legendOffset: 36,
              legendPosition: 'middle'
          }}
          axisLeft={{
              orient: 'left',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'opinions',
              legendOffset: -40,
              legendPosition: 'middle'
          }}
          margin={{ top: 40, right: 80, bottom: 100, left: 80 }}
          colors={{ scheme: 'spectral' }}
          borderWidth={1}
          borderColor={{
              from: 'color',
              modifiers: [
                  [
                      'darker',
                      0.2
                  ]
              ]
          }}
          defs={[
              {
                  id: 'lines',
                  type: 'patternLines',
                  background: 'rgba(0, 0, 0, 0)',
                  color: 'inherit',
                  rotation: -45,
                  lineWidth: 4,
                  spacing: 8
              }
          ]}
          fill={[
              {
                  match: {
                      id: 'agree strongly'
                  },
                  id: 'lines'
              },
              {
                  match: {
                      id: 'disagree strongly'
                  },
                  id: 'lines'
              }
          ]}
          legends={[
              {
                  anchor: 'bottom',
                  direction: 'row',
                  justify: false,
                  translateX: 0,
                  translateY: 80,
                  itemsSpacing: 0,
                  itemWidth: 140,
                  itemHeight: 18,
                  itemTextColor: '#999',
                  itemDirection: 'right-to-left',
                  itemOpacity: 1,
                  symbolSize: 18,
                  symbolShape: 'square',
                  effects: [
                      {
                          on: 'hover',
                          style: {
                              itemTextColor: '#000'
                          }
                      }
                  ]
              }
          ]}
      />
  )

  const MyResponsiveRadar = ({ data /* see data tab */ }) => (
    <ResponsiveRadar
    height={290}
    width={400}
        data={data}
        keys={[ 'chardonay', 'carmenere', 'syrah' ]}
        indexBy="taste"
        valueFormat=">-.2f"
        margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
        borderColor={{ from: 'color' }}
        gridLabelOffset={36}
        dotSize={10}
        dotColor={{ theme: 'background' }}
        dotBorderWidth={2}
        colors={{ scheme: 'nivo' }}
        blendMode="multiply"
        motionConfig="wobbly"
        legends={[
            {
                anchor: 'top-left',
                direction: 'column',
                translateX: -50,
                translateY: -40,
                itemWidth: 80,
                itemHeight: 20,
                itemTextColor: '#999',
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ]
            }
        ]}
    />
)

const MyResponsiveSwarmPlot = ({ data /* see data tab */ }) => (
  <ResponsiveSwarmPlot
      data={data}
      groups={[ 'group A', 'group B', 'group C' ]}
      identity="id"
      value="price"
      valueFormat="$.2f"
      valueScale={{ type: 'linear', min: 0, max: 500, reverse: false }}
      size={{
          key: 'volume',
          values: [
              4,
              20
          ],
          sizes: [
              6,
              20
          ]
      }}
      forceStrength={4}
      simulationIterations={100}
      borderColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  0.6
              ],
              [
                  'opacity',
                  0.5
              ]
          ]
      }}
      margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
      axisTop={{
          orient: 'top',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'group if vertical, price if horizontal',
          legendPosition: 'middle',
          legendOffset: -46
      }}
      axisRight={{
          orient: 'right',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'price if vertical, group if horizontal',
          legendPosition: 'middle',
          legendOffset: 76
      }}
      axisBottom={{
          orient: 'bottom',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'group if vertical, price if horizontal',
          legendPosition: 'middle',
          legendOffset: 46
      }}
      axisLeft={{
          orient: 'left',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'price if vertical, group if horizontal',
          legendPosition: 'middle',
          legendOffset: -76
      }}
  />
)

const MyResponsiveScatterPlot = ({ data /* see data tab */ }) => (
  <ResponsiveScatterPlot
      data={data}
      margin={{ top: 60, right: 140, bottom: 80, left: 90 }}
      xScale={{ type: 'linear', min: 0, max: 'auto' }}
      xFormat=">-.2f"
      yScale={{ type: 'linear', min: 0, max: 'auto' }}
      yFormat=">-.2f"
      blendMode="multiply"
      axisTop={null}
      axisRight={null}
      axisBottom={{
          orient: 'bottom',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'weight',
          legendPosition: 'middle',
          legendOffset: 46
      }}
      axisLeft={{
          orient: 'left',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'size',
          legendPosition: 'middle',
          legendOffset: -60
      }}
      legends={[
          {
              anchor: 'bottom-right',
              direction: 'column',
              justify: false,
              translateX: 130,
              translateY: 0,
              itemWidth: 100,
              itemHeight: 12,
              itemsSpacing: 5,
              itemDirection: 'left-to-right',
              symbolSize: 12,
              symbolShape: 'circle',
              effects: [
                  {
                      on: 'hover',
                      style: {
                          itemOpacity: 1
                      }
                  }
              ]
          }
      ]}
  />
)
const MyResponsiveCirclePacking = ({ data /* see data tab */ }) => (
  <ResponsiveCirclePacking
      data={data}
      margin={{ top: 50, right: 20, bottom: 90, left: 20 }}
      id="name"
      value="loc"
      colors={{ scheme: 'red_purple' }}
      childColor={{
          from: 'color',
          modifiers: [
              [
                  'brighter',
                  0.4
              ]
          ]
      }}
      padding={4}
      enableLabels={true}
      labelsFilter={n=>2===n.node.depth}
      labelsSkipRadius={10}
      labelTextColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  2
              ]
          ]
      }}
      borderWidth={1}
      borderColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  0.5
              ]
          ]
      }}
      defs={[
          {
              id: 'lines',
              type: 'patternLines',
              background: 'none',
              color: 'inherit',
              rotation: -45,
              lineWidth: 5,
              spacing: 8
          }
      ]}
      fill={[
          {
              match: {
                  depth: 1
              },
              id: 'lines'
          }
      ]}
  />
      )
const MyResponsiveStackedBar = ({ data /* see data tab */ }) => (
        <ResponsiveBar
            data={data}
            keys={[
                'hot dog',
                'burger',
                'sandwich',
                'kebab',
                'fries',
                'donut'
            ]}
            indexBy="country"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            padding={0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={{ scheme: 'nivo' }}
            defs={[
                {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: '#38bcb2',
                    size: 4,
                    padding: 1,
                    stagger: true
                },
                {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'inherit',
                    color: '#eed312',
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10
                }
            ]}
            fill={[
                {
                    match: {
                        id: 'fries'
                    },
                    id: 'dots'
                },
                {
                    match: {
                        id: 'sandwich'
                    },
                    id: 'lines'
                }
            ]}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'country',
                legendPosition: 'middle',
                legendOffset: 32,
                truncateTickAt: 0
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'food',
                legendPosition: 'middle',
                legendOffset: -40,
                truncateTickAt: 0
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
            role="application"
            ariaLabel="Nivo bar chart demo"
            barAriaLabel={e=>e.id+": "+e.formattedValue+" in country: "+e.indexValue}
        />
    )      


const  pbdata= {
  datasets: [{
      data: [10, 20, 30],
  }],
  labels: [
      'Red',
      'Yellow',
      'Blue'
  ]
};

const documentStyle = getComputedStyle(document.documentElement);
const textColor = documentStyle.getPropertyValue('--text-color');
const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
const surfaceBorder = documentStyle.getPropertyValue('--surface-border');


const pbsdata = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
      {
          type: 'bar',
          label: 'Finance',
          backgroundColor: '#DAF7A6',
          data: [50, 25, 12, 48, 90, 76, 42]
      },
      {
          type: 'bar',
          label: 'Operation',
          backgroundColor: '#FFC300',
          data: [21, 84, 24, 75, 37, 65, 34]
      },
      {
          type: 'bar',
          label: 'Maintenance',
          backgroundColor: '#FF5733',
          data: [41, 52, 24, 74, 23, 21, 32]
      }
  ]
};
const pbsoptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
      tooltips: {
          mode: 'index',
          intersect: false
      },
      legend: {
          labels: {
              color: '#581845'
          }
      }
  },
  scales: {
      x: {
          stacked: true,
          ticks: {
              color: '#900C3F'
          },
          grid: {
              color: '#C70039'

          }
      },
      y: {
          stacked: true,
          ticks: {
              color: '#99bbc4'
          },
          grid: {
              color: '#99a5c4'
          }
      }
  }
};
      const pbsdataleavebydepartment = pbsdata;
// const pbsdataleavebydepartment = {
//   labels: GraphData[1].map(gender => gender.labels) ,
//   datasets: [
//       {
//           type: 'bar',
//           label: 'Purchase Dep',
//           backgroundColor: getbgcolor( GraphData[9],'Purchase Dep'),
//           data:  GraphData[9].filter(gender =>  gender.labels === 'Purchase Dep').map(gen => gen.data)
//       },
//       {
//         type: 'bar',
//         label: 'Finance',
//         backgroundColor: getbgcolor( GraphData[9],'Finance'),
//         data:  GraphData[9].filter(gender =>  gender.labels === 'Purchase Dep').map(gen => gen.data)
//       },
//         {
//             type: 'bar',
//             label: 'IT Dept',
//             backgroundColor: getbgcolor( GraphData[9],'IT Dept'),
//             data:  GraphData[9].filter(gender =>  gender.labels === 'Purchase Dep').map(gen => gen.data)
//       },
//       {
//           type: 'bar',
//           label: 'HSE',
//           backgroundColor: getbgcolor( GraphData[9],'HSE'),
//           data:  GraphData[9].filter(gender =>  gender.labels === 'HSE').map(gen => gen.data)
//       },
//       {
//         type: 'bar',
//         label: 'HR & Admin',
//         backgroundColor: getbgcolor( GraphData[9],'HR & Admin'),
//         data:  GraphData[9].filter(gender =>  gender.labels === 'HR & Admin').map(gen => gen.data)
//     },
//       {
//           type: 'bar',
//           label: 'HR departmen',
//           backgroundColor: getbgcolor( GraphData[9],'HR departmen'),
//           data:  GraphData[9].filter(gender =>  gender.labels === 'HR departmen').map(gen => gen.data)
//     },
//     {
//       type: 'bar',
//       label: 'Lead Mech En',
//       backgroundColor: getbgcolor( GraphData[9],'Lead Mech En'),
//       data:  GraphData[9].filter(gender =>  gender.labels === 'Lead Mech En').map(gen => gen.data)
//   },
//   {
//     type: 'bar',
//     label: 'Maintenance',
//     backgroundColor: getbgcolor( GraphData[9],'Maintenance'),
//     data:  GraphData[9].filter(gender =>  gender.labels === 'Maintenance').map(gen => gen.data)
//   },
//     {
//         type: 'bar',
//         label: 'Engineering',
//         backgroundColor: getbgcolor( GraphData[9],'Engineering'),
//         data:  GraphData[9].filter(gender =>  gender.labels === 'Engineering').map(gen => gen.data)
//   },
//   {
//       type: 'bar',
//       label: 'Ware House',
//       backgroundColor: getbgcolor( GraphData[9],'Ware House'),
//       data:  GraphData[9].filter(gender =>  gender.labels === 'Ware House').map(gen => gen.data)
//   },
//   {
//     type: 'Lead El Eng',
//     backgroundColor: getbgcolor( GraphData[9],'Lead El Eng'),
//     data:  GraphData[9].filter(gender =>  gender.labels === 'Lead El Eng').map(gen => gen.data)
// },
//   {
//       type: 'bar',
//       label: 'Lead C&I Eng',
//       backgroundColor: getbgcolor( GraphData[9],'Lead C&I Eng'),
//       data:  GraphData[9].filter(gender =>  gender.labels === 'Lead C&I Eng').map(gen => gen.data)
//     },
//     {
//       type: 'bar',
//       label: 'Chemist Depa',
//       backgroundColor: getbgcolor( GraphData[9],'Chemist Depa'),
//       data:  GraphData[9].filter(gender =>  gender.labels === 'Chemist Depa').map(gen => gen.data)
//   },
//   {
//     type: 'Operations',
//     backgroundColor: getbgcolor( GraphData[9],'Operations'),
//     data:  GraphData[9].filter(gender =>  gender.labels === 'Operations').map(gen => gen.data)
// },
//   {
//       type: 'bar',
//       label: 'Security Dep',
//       backgroundColor: getbgcolor( GraphData[9],'Security Dep'),
//       data:  GraphData[9].filter(gender =>  gender.labels === 'Security Dep').map(gen => gen.data)
//   }     
//   ]
// };

      
function getbgcolor(arr, id) {
  return arr.find(array => {
    return array.labels === id;
  })?.backgroundColor || 'hsl(302, 70%, 50%)';
}      
   
const ppdata = {
  datasets: [
      {
          data: [11, 16, 7, 3, 14],
          backgroundColor: [
            '#99bbc4',
              '#DAF7A6',
              '#FFC300',
              '#FF5733',
              '#C70039'
          ],
          label: 'My dataset'
      }
  ],
  labels: ['Red', 'Green', 'Yellow', 'Grey', 'Blue']
};

const ppoptions = {
  plugins: {
      legend: {
          labels: {
              color: '#ADC499',
              position: 'bottom',
              display: false
          }
          
      }
  },
  scales: {
      r: {
          grid: {
              color: '#999FC4'
          }
      }
  }
};

function extLegend() 
{
    this.cfg.legend= {
        show: true,
        location: 's',
        placement: 'outsideGrid',
        position: 'left'
    };
}

const pdoughdata = {
  labels: ['Direct Employee', 'Contract Employee'],
  datasets: [
      {
          data: [300, 50],
          hoverBackgroundColor : [
            '#ADC499', 
            '#999FC4'
          ],
          backgroundColor : [
            '#FF5733', 
            '#FFC300'
          ]
      }
  ]
      };
      const pdoughdatagender = pdoughdata;
      // const pdoughdatagender1 = {
      //   labels:GraphData[1].map(gender => gender.labels),
      //   datasets: [
      //       {
      //           data: GraphData[1].map(gender => gender.data),
      //           backgroundColor: GraphData[1].map(gender => gender.backgroundColor),
      //           hoverBackgroundColor:  GraphData[1].map(gender => gender.backgroundColor)
      //       }
      //   ]
      // };

      const pdoughdataemptype = {
        labels: ['Direct Employee', 'Contract Employee'],
        datasets: [
            {
                data: [300, 50],
                hoverBackgroundColor : [
                  '#ADC499', 
                  '#999FC4'
                ],
                backgroundColor : [
                  '#FF5733', 
                  '#FFC300'
                ]
            }
        ]
      };
      // const pdoughdataemptype2 = {
      //   labels: [GraphData[12].map(gen => gen.labels)],
      //   datasets: [
      //       {
      //           data: [GraphData[12].map(gen => gen.data)],
      //           hoverBackgroundColor : [
      //             '#ADC499', 
      //             '#999FC4'
      //           ],
      //           backgroundColor : [
      //             '#FF5733', 
      //             '#FFC300'
      //           ]
      //       }
      //   ]
      //       };
      const labels = ['Muhammed', 'David', 'Abdul Kader', 'Selvan', 'Yousuf'];
      const databartbestemp = {
        labels: labels,
        datasets: [{
          label: 'Best Employee of the Month',
          data: [81, 60, 50, 40, 30],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
          ],
          borderWidth: 1
        }]
      };

      // const labels12 = [GraphData[12].map(gen => gen.labels)];
      // const databartbestemp12 = {
      //   labels: labels12,
      //   datasets: [{
      //     label: 'Best Employee of the Month',
      //     data: [GraphData[12].map(gen => gen.data)],
      //     backgroundColor: [
      //       'rgba(255, 99, 132, 0.2)',
      //       'rgba(255, 159, 64, 0.2)',
      //       'rgba(255, 205, 86, 0.2)',
      //       'rgba(75, 192, 192, 0.2)',
      //       'rgba(54, 162, 235, 0.2)',
      //     ],
      //     borderColor: [
      //       'rgb(255, 99, 132)',
      //       'rgb(255, 159, 64)',
      //       'rgb(255, 205, 86)',
      //       'rgb(75, 192, 192)',
      //       'rgb(54, 162, 235)',
      //     ],
      //     borderWidth: 1
      //   }]
      // };

      const pdoughdata1 = {
        labels: ['Muhammed Abdullah', 'David Johson','Abdul Kader', 'Tamil Selvan', 'Yousuf'],
        datasets: [
            {
                data: [10, 20,30,40,50,60],
                backgroundColor: [
                  '#ADC499', 
                  '#999FC4', 
                  '#C70039',
                  '#899FC4', 
                  '#C80039'
                ],
                hoverBackgroundColor: [
                  '#FF5733', 
                  '#FFC300', 
                  '#FF6733',
                  '#FFC500', 
                  '#FF7733'
                ]
            }
        ]
      };
      
      const pdoughdata2 = {
        labels: ['Indian', 'Kuwaiti','Pakistani', 'Srilankan', 'Filipino'],
        datasets: [
            {
                data: [100, 40,30,20,150,10],
                backgroundColor: [
                  '#999FC4', 
                  '#C70039',
                  '#ADC499', 
                  '#cf5cb6', 
                  '#7e5702'
                ],
                hoverBackgroundColor: [
                  '#FF5733', 
                  '#FFC300', 
                  '#FF6733',
                  '#FFC500', 
                  '#FF7733'
                ]
            }
        ]
      };

      const pdoughdata3 = {
        labels: ['Male', 'Female','Trans Gender'],
        datasets: [
            {
                data: [100, 40,30],
                backgroundColor: [
                  '#ADC499', 
                  '#999FC4', 
                  '#C70039'
                ],
                hoverBackgroundColor: [
                  '#FF5733', 
                  '#FFC300', 
                  '#FF6733'
                ]
            }
        ]
      };
      
      const pdoughdata4 = {
        labels: ['Annual Leave', 'Sick Leave 100% Paid', 'Compassionate Leave', 'Sick Leave 75% Paid'],
        datasets: [
            {
                data: [300, 50,20,30],
                backgroundColor: [
                  '#ADC499', 
                  '#999FC4', 
                  '#C70039'
                ],
                hoverBackgroundColor: [
                  '#FF5733', 
                  '#FFC300', 
                  '#FF5733'
                ]
            }
        ]
            };

      const pdoughdatanationality = pdoughdata;
      // const pdoughdatanationality0 = {
      //   labels:GraphData[0].map(Nationa => Nationa.labels),
      //   datasets: [
      //       {
      //           data: GraphData[0].map(Nationa => Nationa.data),
      //           backgroundColor: GraphData[0].map(Nationa => Nationa.backgroundColor),
      //           hoverBackgroundColor:  GraphData[0].map(Nationa => Nationa.backgroundColor)
      //       }
      //   ]
      // };


const pdoughoptions = {
  cutout: 500,
  radius: 190,
};

const baroptions= {
  scales: {
    y: {
      beginAtZero: true
    }
  }
}     
      
const pbvdata = {
  labels: ['Finance', 'HR and Administration', 'Operation', 'Maintenance', 'Warehouse', 'Sale and Marketing', 'Information Technology'],
  datasets: [
      {
          label: 'Age Group- 30 - 40',
          backgroundColor: '#ADC499',
          borderColor: '#FF5733',
          data: [28, 48, 40, 19, 86, 27, 90]
      },
      {
          label: 'Age Group - 40 - 50',
          backgroundColor: '#999FC4',
          borderColor: '#FFC300',
          data: [28, 48, 40, 19, 86, 27, 90]
    },
    {
      label: 'Age Group - 50 - 60',
      backgroundColor: '#0820be',
      borderColor: '#FFC300',
      data: [28, 48, 40, 19, 86, 27, 90]
  }
  ]
      };

      // const pbvdataagegroup = {
      //   labels: GraphData[1].map(gen => gen.name),
      //   datasets: [
      //       {
      //           label: 'Age Group- 30 - 40',
      //           backgroundColor: '#ADC499',
      //           borderColor: '#FF5733',
      //           data: GraphData[1].filter(gender =>  gender.agegoup === '30 - 40').map(gen => gen.data)
      //       },
      //       {
      //           label: 'Age Group - 40 - 50',
      //           backgroundColor: '#999FC4',
      //           borderColor: '#FFC300',
      //           data: GraphData[1].filter(gender =>  gender.agegoup === '40 - 50').map(gen => gen.data)
      //     },
      //     {
      //       label: 'Age Group - 50 - 60',
      //       backgroundColor: '#999FC4',
      //       borderColor: '#FFC300',
      //       data: GraphData[1].filter(gender =>  gender.agegoup === '50 - 60').map(gen => gen.data)
      //   }
      //   ]
      // };     
      
      const pbvdataagegroup = pbvdata; 

const pbvoptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
      legend: {
          labels: {
              fontColor: '#FF5733'
          }
      }
  },
  scales: {
      x: {
          ticks: {
              color: '#C70039',
              font: {
                  weight: 500
              }
          },
          grid: {
              display: false,
              drawBorder: false
          }
      },
      y: {
          ticks: {
              color: '#C70039'
          },
          grid: {
              color: '#C70039',
              drawBorder: false
          }
      }
  }
};

const pldata1 = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
      {
          label: 'Finance',
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4
      },
      {
        label: 'Hr and Admin',
        data: [25, 19, 10, 21, 36, 15, 60],
        fill: false,
        borderColor: documentStyle.getPropertyValue('--blue-500'),
        tension: 0.4
    },
    {
      label: 'Operation',
      data: [21, 12, 20, 11, 16, 25, 10],
      fill: false,
      borderColor: documentStyle.getPropertyValue('--blue-500'),
      tension: 0.4
    },  
    {
      label: 'Maintenance',
      data: [5, 9, 12, 11, 16, 11, 10],
      fill: false,
      borderColor: documentStyle.getPropertyValue('--blue-500'),
      tension: 0.4
  },       
      // {
      //     label: 'Second Dataset',
      //     data: [28, 48, 40, 19, 86, 27, 90],
      //     fill: false,
      //     borderColor: documentStyle.getPropertyValue('--pink-500'),
      //     tension: 0.4
      // }
  ]
};      
      

const pldata = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
      {
          label: 'First Dataset',
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4
      },
      // {
      //     label: 'Second Dataset',
      //     data: [28, 48, 40, 19, 86, 27, 90],
      //     fill: false,
      //     borderColor: documentStyle.getPropertyValue('--pink-500'),
      //     tension: 0.4
      // }
  ]
};
      const pldataLeaveTaken = pldata;
// const pldataLeaveTaken = {
//   labels: GraphData[6].map(gen => gen.months),
//   datasets: [
//       {
//           label: 'Annual Leave',
//           data:  GraphData[6].filter(leave =>  leave.labels === 'Annual Leave').map(gen => gen.data),
//           fill: false,
//           borderColor: documentStyle.getPropertyValue('--blue-500'),
//           tension: 0.4
//     },
//     {
//       label: 'Sick leave 100% Paid',
//       data:  GraphData[6].filter(leave =>  leave.labels === 'Sick leave 100% Paid').map(gen => gen.data),
//       fill: false,
//       borderColor: documentStyle.getPropertyValue('--pink-500'),
//       tension: 0.4
//     }, 
//     {
//       label: 'Sick leave 75% Paid',
//       data:  GraphData[6].filter(leave =>  leave.labels === 'Sick leave 75% Paid').map(gen => gen.data),
//       fill: false,
//       borderColor: documentStyle.getPropertyValue('--pink-500'),
//       tension: 0.4
//     },  
//     {
//       label: 'Comp - Off',
//       data:  GraphData[6].filter(leave =>  leave.labels === 'Comp - Off').map(gen => gen.data),
//       fill: false,
//       borderColor: documentStyle.getPropertyValue('--green-500'),
//       tension: 0.4
//     }, 
//     {
//       label: 'Compassionate Leave',
//       data:  GraphData[6].filter(leave =>  leave.labels === 'Compassionate Leave').map(gen => gen.data),
//       fill: false,
//       borderColor: documentStyle.getPropertyValue('--grey-500'),
//       tension: 0.4
//     }, 
//       // {
//       //     label: 'Second Dataset',
//       //     data: [28, 48, 40, 19, 86, 27, 90],
//       //     fill: false,
//       //     borderColor: documentStyle.getPropertyValue('--pink-500'),
//       //     tension: 0.4
//       // }
//   ]
// };
      
const ploptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.6,
  plugins: {
      legend: {
          labels: {
              color: '#C70039'
          }
      }
  },
  scales: {
      x: {
          ticks: {
              color:'#FF5733'
          },
          grid: {
              color: '#999FC4'
          }
      },
      y: {
          ticks: {
              color: '#FF5733'
          },
          grid: {
              color: '#999FC4'
          }
      }
  }
};


const ppiedata = {
  labels: ['Finance Manager', 'Process Engineer', 'HR Business Partner'],
  datasets: [
      {
          data: [540, 325, 702],
          backgroundColor: [
              '#DDB7DF ', 
              '#6968AF', 
              '#834011 '
          ],
          hoverBackgroundColor: [
              '#E93B33 ', 
              '#ECC968', 
              '#070501'
          ]
      }
  ]
      }
      const ppiedataLeavebyleavetype = ppiedata;
// const ppiedataLeavebyleavetype = {
// labels:  GraphData[5].map(gen => gen.labels),
// datasets: [
//     {
//         data: GraphData[5].map(gen => gen.data),
//         backgroundColor: [
//             '#DDB7DF ', 
//             '#6968AF', 
//             '#834011 '
//         ],
//         hoverBackgroundColor: [
//             '#E93B33 ', 
//             '#ECC968', 
//             '#070501'
//         ]
//     }
// ]
// }
const ppieoptions = {
  plugins: {
      legend: {
          labels: {
              usePointStyle: true
          }
      }
  }
};

// const stackedbardata = [
//   {
//     "country": "AD",
//     "hot dog": 36,
//     "hot dogColor": "hsl(244, 70%, 50%)",
//     "burger": 129,
//     "burgerColor": "hsl(53, 70%, 50%)",
//     "sandwich": 186,
//     "sandwichColor": "hsl(319, 70%, 50%)",
//     "kebab": 184,
//     "kebabColor": "hsl(206, 70%, 50%)",
//     "fries": 194,
//     "friesColor": "hsl(83, 70%, 50%)",
//     "donut": 28,
//     "donutColor": "hsl(11, 70%, 50%)"
//   },
//   {
//     "country": "AE",
//     "hot dog": 64,
//     "hot dogColor": "hsl(235, 70%, 50%)",
//     "burger": 100,
//     "burgerColor": "hsl(25, 70%, 50%)",
//     "sandwich": 117,
//     "sandwichColor": "hsl(348, 70%, 50%)",
//     "kebab": 157,
//     "kebabColor": "hsl(40, 70%, 50%)",
//     "fries": 175,
//     "friesColor": "hsl(62, 70%, 50%)",
//     "donut": 73,
//     "donutColor": "hsl(202, 70%, 50%)"
//   },
//   {
//     "country": "AF",
//     "hot dog": 189,
//     "hot dogColor": "hsl(33, 70%, 50%)",
//     "burger": 174,
//     "burgerColor": "hsl(92, 70%, 50%)",
//     "sandwich": 149,
//     "sandwichColor": "hsl(217, 70%, 50%)",
//     "kebab": 140,
//     "kebabColor": "hsl(354, 70%, 50%)",
//     "fries": 160,
//     "friesColor": "hsl(171, 70%, 50%)",
//     "donut": 187,
//     "donutColor": "hsl(197, 70%, 50%)"
//   },
//   {
//     "country": "AG",
//     "hot dog": 183,
//     "hot dogColor": "hsl(228, 70%, 50%)",
//     "burger": 133,
//     "burgerColor": "hsl(91, 70%, 50%)",
//     "sandwich": 63,
//     "sandwichColor": "hsl(148, 70%, 50%)",
//     "kebab": 112,
//     "kebabColor": "hsl(74, 70%, 50%)",
//     "fries": 142,
//     "friesColor": "hsl(181, 70%, 50%)",
//     "donut": 106,
//     "donutColor": "hsl(73, 70%, 50%)"
//   },
//   {
//     "country": "AI",
//     "hot dog": 109,
//     "hot dogColor": "hsl(229, 70%, 50%)",
//     "burger": 108,
//     "burgerColor": "hsl(25, 70%, 50%)",
//     "sandwich": 36,
//     "sandwichColor": "hsl(47, 70%, 50%)",
//     "kebab": 118,
//     "kebabColor": "hsl(194, 70%, 50%)",
//     "fries": 179,
//     "friesColor": "hsl(52, 70%, 50%)",
//     "donut": 127,
//     "donutColor": "hsl(194, 70%, 50%)"
//   },
//   {
//     "country": "AL",
//     "hot dog": 45,
//     "hot dogColor": "hsl(140, 70%, 50%)",
//     "burger": 28,
//     "burgerColor": "hsl(51, 70%, 50%)",
//     "sandwich": 82,
//     "sandwichColor": "hsl(203, 70%, 50%)",
//     "kebab": 49,
//     "kebabColor": "hsl(30, 70%, 50%)",
//     "fries": 167,
//     "friesColor": "hsl(327, 70%, 50%)",
//     "donut": 143,
//     "donutColor": "hsl(27, 70%, 50%)"
//   },
//   {
//     "country": "AM",
//     "hot dog": 90,
//     "hot dogColor": "hsl(78, 70%, 50%)",
//     "burger": 88,
//     "burgerColor": "hsl(147, 70%, 50%)",
//     "sandwich": 103,
//     "sandwichColor": "hsl(345, 70%, 50%)",
//     "kebab": 26,
//     "kebabColor": "hsl(273, 70%, 50%)",
//     "fries": 11,
//     "friesColor": "hsl(148, 70%, 50%)",
//     "donut": 195,
//     "donutColor": "hsl(336, 70%, 50%)"
//   }
// ]      
    
        // let headCountData =[];// (requestListData[9] && requestListData[9].length > 0 ) ? requestListData[9] : [];
        // let cityOfficeHc= (headCountData && headCountData.length > 0  && headCountData.find(el =>el.status == "City Office Head Count")) ? headCountData.find(el =>el.status == "City Office Head Count") : {count: 0};
        // let ccrHc = (headCountData && headCountData.length > 0  &&  headCountData.find(el => el.status == "CCR HC - Assembly Point")) ? headCountData.find(el => el.status == "CCR HC - Assembly Point") : {count: 0};
        // let siteHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Site HeadCount")) ? headCountData.find(el => el.status == "Site HeadCount") : {count: 0};
        // let mainGateHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Main Gate HC - Assembly Point")) ? headCountData.find(el => el.status == "Main Gate HC - Assembly Point") : {count: 0};
        // let seaWaterHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Sea Water HC - Assembly Point")) ? headCountData.find(el => el.status == "Sea Water HC - Assembly Point") : {count: 0};
        // let missingHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Missing Head Count - Site")) ? headCountData.find(el => el.status == "Missing Head Count - Site") : {count: 0};
        // head count display calculation end
        let headCountData =[];// (requestListData[9] && requestListData[9].length > 0 ) ? requestListData[9] : [];
        let cityOfficeHc= (headCountData && headCountData.length > 0  && headCountData.find(el =>el.status == "City Office Head Count")) ? headCountData.find(el =>el.status == "City Office Head Count") : {count: 560};
        let ccrHc = (headCountData && headCountData.length > 0  &&  headCountData.find(el => el.status == "CCR HC - Assembly Point")) ? headCountData.find(el => el.status == "CCR HC - Assembly Point") : {count: 700};
        let siteHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Site HeadCount")) ? headCountData.find(el => el.status == "Site HeadCount") : {count: 53};
        let mainGateHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Main Gate HC - Assembly Point")) ? headCountData.find(el => el.status == "Main Gate HC - Assembly Point") : {count: 24};
        let seaWaterHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Sea Water HC - Assembly Point")) ? headCountData.find(el => el.status == "Sea Water HC - Assembly Point") : {count: 10};
        let missingHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Missing Head Count - Site")) ? headCountData.find(el => el.status == "Missing Head Count - Site") : {count: 5};


      let porganizationData = {};
        if(this.props.positionhierarchyData && this.props.positionhierarchyData.length > 0 ){
          porganizationData = this.props.positionhierarchyData
       //  let organizationData = [...new Set(organizationData.map(({ name,color,loc,children }) => ({name,color,loc,children})))];
        porganizationData = {...porganizationData.map(({ name, color, children }) => ({name,color,
            children: children.map(({ name,color,children }) => ({name,color,children: children.map(({name,color, children }) => ({name,color,children:children.map(({ name,color,loc }) => ({name,color,loc })) })) })),
          }))};

       //   porganizationData = {...porganizationData.map(({ name,color,children }) => ({name,color,children}))};
       porganizationData = porganizationData["0"];  
       this.setState({ organizationData:porganizationData});
          
         }

         const organizationData = porganizationData;
        return(

            

          
            <div className="p-grid">
                {/* { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
            <Toast ref={(el) => this.growl = el} /> */}

                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                {/* {(this.getVideoAccess !== undefined && this.getVideoAccess.viewAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title">
                            <h1>Feature Videos</h1>
                            {(this.props.companyData && this.props.companyData.company !== undefined) &&
                                <FeatureVideo companyDetails={this.props.companyData.company} />
                            }
                        </div>
                    </div>
                } */}


                <div className="p-col-12">


    
                  
                    <div className="card" style={{position:'relative'}}>


                        <div className="mt1 p-col-12">
                            <h1>HR Summary Dashboard</h1>
                        </div>
                        <div className="p-grid p-justify-start">
                        {/* <div className="p-col-12">
                                <MultiSelect className="p-col-12" name="SelectedOrg" optionLabel="label" placeholder="Select Business Unit" options={this.state.Department} value={this.state.SelectedOrg} onChange={(e) => this.setState({ SelectedOrg: e.value })}  />
                            </div> */}
                                {/* <Calendar className="p-col-3" id="monthpicker" value={null} onChange={(e) => this.setState({ date10: e.value })} view="month" dateFormat="mm/yy" yearNavigator yearRange="2000:2030" placeholder="Month"/> */}
                                <Calendar     className="p-col-3" id="fromdate" value={null} onChange={(e) => this.setState({ dateFrom: e.value })} monthNavigator yearNavigator yearRange="2000:2030" placeholder="From Date"/>
                
                                <Calendar     className="p-col-3" id="Todate" value={null} onChange={(e) => this.setState({ dateTo: e.value })} monthNavigator yearNavigator yearRange="2000:2030" placeholder="To Date"/>
                
                            

                </div>
                
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>HR Statistics (As of Current Month)</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-even">

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center', }} 
                                        header={<div style={{backgroundColor:'#406882', color:'#F6F6F6',textAlign: 'center', padding:'1px',  minHeight: '65px'}}><h3>Total Employee</h3></div>}
                                        // footer = {this.headCountFooter('City Office Head Count')}
                                        >
                                        <span style={{color:'#5F021F',  backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{cityOfficeHc.count}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882',color:'#F6F6F6', textAlign: 'center', padding:'1px',  minHeight: '65px'}}><h3>OverTime Hours</h3></div>}
                                        // footer = {this.headCountFooter('CCR HC - Assembly Point')}
                                        >
                                        <span style={{color:'#406882',  backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{ccrHc.count}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{ textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6',minHeight: '65px'}}><h3>BreakPermission Hours </h3></div>}
                                        // footer = {this.headCountFooter('Site HeadCount')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', color:'#FF9900', padding:'1px' , fontSize: '55px'}}>{siteHc.count}</span>
                                    </Card>
                                    </div> 

                                    {(ccrHc.count > 0 || mainGateHc.count > 0 ||  seaWaterHc.count > 0) && 
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                        <Card 
                                            style={{textAlign: 'center',}} 
                                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color: '#F6F6F6', minHeight: '65px'}}><h3>UnApproved Absence</h3></div>}
                                            // footer = {this.headCountFooter('Missing Head Count - Site')}
                                            >
                                            <span style={{color: '#CC3333', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{missingHc.count}</span>
                                        </Card>
                                    </div> 
                                    }

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Annual Leave</h3></div>}
                                        // footer = {this.headCountFooter('Main Gate HC - Assembly Point')}
                                        >
                                        <span style={{color:'#6A6A5A', backgroundColor:   'F9F3F3', padding:'1px' , fontSize: '55px'}}>{mainGateHc.count}</span>
                                    </Card>
                                    </div>                         

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Sick Leave</h3></div>}
                                        // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                        >
                                        <span style={{color:'#FFCC00', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{seaWaterHc.count}</span>  
                                    </Card>
                                    </div> 
                                </div>
                            </div>
                        </div>  
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>ITSM Statistics (As of Current Month)</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-even">

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center', }} 
                                        header={<div style={{backgroundColor:'#406882', color:'#F6F6F6',textAlign: 'center', padding:'1px',  minHeight: '65px'}}><h3>Total Tickets</h3></div>}
                                        // footer = {this.headCountFooter('City Office Head Count')}
                                        >
                                        <span style={{color:'#5F021F',  backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{cityOfficeHc.count}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882',color:'#F6F6F6', textAlign: 'center', padding:'1px',  minHeight: '65px'}}><h3>Tickets In Dispatcher</h3></div>}
                                        // footer = {this.headCountFooter('CCR HC - Assembly Point')}
                                        >
                                        <span style={{color:'#406882',  backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{ccrHc.count}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{ textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6',minHeight: '65px'}}><h3>Tickets In Queue </h3></div>}
                                        // footer = {this.headCountFooter('Site HeadCount')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', color:'#FF9900', padding:'1px' , fontSize: '55px'}}>{siteHc.count}</span>
                                    </Card>
                                    </div> 

                                    {(ccrHc.count > 0 || mainGateHc.count > 0 ||  seaWaterHc.count > 0) && 
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                        <Card 
                                            style={{textAlign: 'center',}} 
                                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color: '#F6F6F6', minHeight: '65px'}}><h3>Tickets In Service </h3></div>}
                                            // footer = {this.headCountFooter('Missing Head Count - Site')}
                                            >
                                            <span style={{color: '#CC3333', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{missingHc.count}</span>
                                        </Card>
                                    </div> 
                                    }

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Closed Tickets</h3></div>}
                                        // footer = {this.headCountFooter('Main Gate HC - Assembly Point')}
                                        >
                                        <span style={{color:'#6A6A5A', backgroundColor:   'F9F3F3', padding:'1px' , fontSize: '55px'}}>{mainGateHc.count}</span>
                                    </Card>
                                    </div>                         

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Sick Leave</h3></div>}
                                        // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                        >
                                        <span style={{color:'#FFCC00', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{seaWaterHc.count}</span>  
                                    </Card>
                                    </div> 
                                </div>
                            </div>
                        </div>  
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Employees</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around">

                                    {/* <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>HeadCount</h3>
                                        <Chart type="line" data={pldata} options={ploptions}  />
                                    </div> */}
                      
                                    {/* <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance Department-wise</h3>
                                            <MyResponsiveStackedBar data={stackedbardata}/>

                                    </div>*/}
                                    
                                    <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>HeadCount by Contract Type</h3>
                                        <Chart type="doughnut" data={pdoughdata} options={pdoughoptions} />
                                    </div>
                                    
                      <div className="mt1 " style={{textAlign: 'center', height: 650, width: 600, margin: "0", padding: "0" }}>
                                        <h3>Best Employees of Month(Attendance wise)</h3>
                                        <Chart type="bar" data={databartbestemp} options={baroptions} />
                                    </div>
                                    
                      <div className="mt1 " style={{ textAlign: 'center', height: 450, width: 500, margin: "0", padding: "0" }}>
                                        <h3>Open Positions Department-wise</h3>
                                        <Chart type="pie" data={ppiedata} options={ppieoptions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Diversity</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around" >
                                    <div className="" style={{textAlign: 'center'}}>
                                        <h3>HeadCount by Nationality</h3>
                                        <Chart type="doughnut" data={pdoughdata2} options={pdoughoptions}/>
                                    </div>
                                    
                                    <div className="" style={{textAlign: 'center'}}>
                                        <h3>HeadCount by Gender</h3>
                                        <Chart type="doughnut" data={pdoughdata3} options={pdoughoptions} />
                                    </div>
                                    
                                    <div className="" style={{textAlign: 'center'}}>
                                        <h3>HeadCount by Age Range</h3>
                                        <Chart type="bar" data={pbvdata} options={pbvoptions} />
                                    </div>
                                    
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12">
                                        <Card 
                                           style={{textAlign: 'center',backgroundColor: '#D2DDCA'}} 
                                            header={<div style={{textAlign: 'center', padding:'1px',  minHeight: '50px'}}><h3>Average Age</h3></div>}
                                            // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                            >
                                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{"44.1"}</span>
                                            <h3>Years</h3>
                                        </Card>
                                    </div> 

                                </div>
                            </div>
                        </div>



                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Leave Days</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around" >
                                    {/* <div className="">
                                        <h3>Leave Taken</h3>
                                        <Chart type="line" data={pldata1} options={ploptions} />
                                    </div> */}
                                    
                                    <div className="" style={{textAlign: 'center', height: 650, width: 600, margin: "0", padding: "0" }}>
                                        <h3>Leave Taken by Category</h3>
                                        <Chart type="doughnut" data={pdoughdata4} options={pdoughoptions} />
                                    </div>
                                    
                                    
                                    <div className="mt1 " style={{textAlign: 'center', height: 650, width: 600, margin: "0", padding: "0" }}>
                                        <h3>Department-Wise Leave</h3>
                                        <Chart type="bar" data={pbsdata} options={pbsoptions}
                                        
                                        />
                                    </div>
                                    
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12">
                                        <Card 
                                            style={{textAlign: 'center',}} 
                                            header={<div style={{backgroundColor:'#FF5733', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '50px'}}><h3>Cost Of Remaining Annual Leave</h3></div>}
                                            // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                            >
                                            <span style={{ backgroundColor: '#FF5733', padding:'1px' , fontSize: '45px'}}>{"$09.3 "}</span>
                                            <h3>Million</h3>
                                        </Card>
                                    </div> 

                                </div>
                            </div>
                        </div>
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Absence Analytics</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                                                  
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Department-wise Absence</h3>
                                            {/* <MyResponsiveLine data={dline}/> */}

                                    </div>
                                </div>

                            </div>
                </div> 
                
                <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Expense Claim</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Expense by Department</h3>
                                            <MyResponsivePie data={piedExpenseDepartment}/>

                                    </div>
                                 
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Expense by Category</h3>
                                            <MyResponsivePie data={piedOTpercentage}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Top and Least Expense By Category</h3>
                                            <MyResponsivePie data={pieexpensebyhighlow}/>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Check-In Times</h3>
                                            <MyResponsivePie data={piedcheckintime}/>

                                    </div>
                                 
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Overtime Hours - Monthwise</h3>
                                            <MyResponsivePie data={piedOTpercentage}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance - Top 5 Employee of Month</h3>
                                            <MyResponsivePie data={piedbestemployeeofmonth}/>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin:{ top: 80, right: 100, bottom: 80, left: 100 }, padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Time and Attendance</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around">
                                    <div className="p-col-3">
                                        <h3>Leave Taken</h3>
                                        <Chart type="polarArea" data={ppdata} options={ppoptions} style={{  height: 450,width:400,margin: "0", padding: "0" } }
                                        
                                        />
                                    </div>


                                    <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>Department-Wise Absence Rate 1</h3>
                                        <Chart type="bar" data={pbsdata} options={pbsoptions}
                                        
                                        />
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12">
                                        <Card 
                                            style={{textAlign: 'center',backgroundColor: '#C70039'}} 
                                            // header={<div style={{backgroundColor:'#808080', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '50px'}}><h3>Cost Of Remaining Annual Leave</h3></div>}
                                            // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                            >
                                            <span style={{ backgroundColor: '#C70039', padding:'1px' , fontSize: '45px'}}>{"1.13%"}</span>
                                            <h3>Abesentism Per Month </h3>
                                        </Card>
                                    </div> 
                                </div>
                            </div>
                        </div>                                              

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Employee Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise</h3>
                                            <MyResponsiveAreaBump data={bumpd}/>

                                    </div>


                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance Department-wise</h3>
                                            <MyResponsiveBump data={bumpd}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance Department-wise</h3>
                                            <MyResponsiveBump data={bumpd}/>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   

                                 
                                    <div className="mt1 "  style={{textAlign: 'center',height: 350,width:550 }}>
                                        <h3>Open Positions Department-wise</h3>
                                        <MyResponsiveScatterPlot data={dscatter}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center',height: 350,width:550 }}>
                                        <h3>Attendance Department-wise</h3>
                                        <MyResponsiveSwarmPlot  data={dswarm}  colors={{scheme: 'category10'}} />

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo66</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                   
                                <div className="mt1 "  style={{textAlign: 'center',height: 390,width:390 }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveChord data={chordd}/>

                                    </div>
                                   
                                    <div className="mt1 "  style={{textAlign: 'center',height: 700,width:750 }}>
                                        <h3>Organization Structure</h3>
                                            <MyResponsiveCirclePacking data={organizationData}/>

                                    </div>

                                </div>

                            </div>
                        </div>                        

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveFunnel data={dfun}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            {/* <MyResponsiveHeatMap data={dheat}/> */}

                                    </div>
                                 
                                </div>

                            </div>
                        </div>
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveMarimekko data={dmarimekko}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveRadar data={dradar}/>

                                    </div>
                                 
                                </div>

                            </div>
                        </div>


                        


                        {/* <div className="mt1 p-col-12 p-grid">
                            <div className="p-col-2" style={{backgroundColor:'#406882'}}>
                                <h4>Live Head Count</h4>
                            </div>

                        </div>

                        <div className="mt1 pcol-12 p-grid">
                            <div className="pcol-2" style={{backgroundColor:'#406882'}}>
                                <h4>Leave Days</h4>
                            </div>

                        </div>

                        <div className="mt1 pcol-12 p-grid">
                            <div className="pcol-2" style={{backgroundColor:'#406882'}}>
                                <h4>Time and Attendance</h4>
                            </div>

                        </div> */}
                        
                        
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        OrgUnit: (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        loginUserDetail: state.auth.userDetail,
        userPref : state.auth.userPref,
        // wpCertificateDetails: state.master.tableLists,
        // requestListData: state.master.requestListData,
        positionhierarchyData: state.master.positionhierarchyData,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequest: (value) => dispatch(actions.getRequest(value)),
        //getCalendarData: (empId, model, fromDate, toDate) => dispatch(actions.getCalendarData(empId, model, fromDate, toDate)),
        GetPositionHierachyGraph: (value) => dispatch(actions.GetPositionHierachyGraph(value)),

    }
}



export default connect(mapStateToProps, mapDispatchToProps)(OrgStruct);